import { ScrollSmoother } from "gsap/ScrollSmoother";
import { gsap } from "gsap";
//import { doc } from "prettier";

//Flickity logo slider
document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(".sponsor-carousel");
  carousels.forEach((carousel) => {
    new Flickity(carousel, {
      // Fade-Effekt (benötigt flickity-fade.js)
      fade: true,
      // Automatische Rotation
      autoPlay: 4000, // 4 Sekunden
      selectedAttraction: 0.01,
      friction: 0.45,
      pauseAutoPlayOnHover: false,
      // Endlos-Loop
      wrapAround: true,
      // Keine UI-Elemente
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
    });
  });
});

//Random Background Color && Clip Path Color
document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  // Speichert die zuletzt verwendete Farbe für jedes Element
  let lastUsedColors = {
    hero: null,
    kleinHero: null,
    textopening: null,
    titelLink: null,
    scrollContainer: null,
    general: null,
  };

  function getRandomColor(colors, lastColor) {
    // Filtere die zuletzt verwendete Farbe aus den Optionen
    const availableColors = lastColor ? colors.filter((color) => color !== lastColor) : colors;
    // Wähle eine zufällige Farbe aus den verfügbaren
    return availableColors[Math.floor(Math.random() * availableColors.length)];
  }

  function randomizeBgColor() {
    // 1. Select elements
    const animations = document.querySelectorAll(".random-bg");
    const bgColors = document.querySelectorAll(".bg-random");
    const colors = ["rgb(255,92,87)", "rgb(80,70,196)", "rgb(255,220,0)", "rgb(0,215,147)"];

    // 2. Prüfen, ob überhaupt Elemente vorhanden sind, die gefärbt werden müssen
    if (bgColors.length === 0 && animations.length === 0) {
      console.warn("No .bg-random or .random-bg elements found");
      return;
    }

    // 3. Unterscheide zwischen verschiedenen Element-Typen
    const heroAnimations = document.querySelectorAll(".hero .random-bg");
    const kleinHeroAnimations = document.querySelectorAll(".klein-hero .random-bg");
    const textopeningAnimations = document.querySelectorAll(".textopening .random-bg");
    const scrollContainers = document.querySelectorAll(".scroll-container .bg-random");
    const otherAnimations = Array.from(animations).filter(
      (anim) =>
        !anim.closest(".hero") && !anim.closest(".klein-hero") && !anim.closest(".textopening"),
    );

    // Liste aller verwendeten Farben für diese Seite
    const usedColorsOnThisPage = [];

    // Spezialbehandlung für Hero-Bereich (nur ein zufälliges Animation anzeigen)
    if (heroAnimations.length > 0) {
      // Hide all hero animations
      heroAnimations.forEach((anim) => (anim.style.display = "none"));

      // Select random animation for hero
      const randomIndex = Math.floor(Math.random() * heroAnimations.length);
      const selectedAnimation = heroAnimations[randomIndex];
      selectedAnimation.style.display = "grid";

      // Neue Farbe wählen, die sich von der letzten unterscheidet
      const newColor = getRandomColor(colors, lastUsedColors.general);
      lastUsedColors.hero = newColor;
      lastUsedColors.general = newColor;
      usedColorsOnThisPage.push(newColor);

      // Setzt die Farbe für die ausgewählte Hero-Animation
      applyColorsToSection(selectedAnimation, [newColor]);
    }

    // Spezialbehandlung für Scroll-Container - DIREKT NACH HERO
    // Wähle eine Farbe, die sich von der Hero-Farbe unterscheidet
    if (scrollContainers.length > 0) {
      // Neue Farbe wählen - hier explizit von der letzten Farbe auf der Seite abgrenzen
      const lastUsedOnPage =
        usedColorsOnThisPage.length > 0
          ? usedColorsOnThisPage[usedColorsOnThisPage.length - 1]
          : lastUsedColors.general;
      const newColor = getRandomColor(colors, lastUsedOnPage);

      lastUsedColors.scrollContainer = newColor;
      lastUsedColors.general = newColor;
      usedColorsOnThisPage.push(newColor);

      // Setze die Farbe für alle bg-random Elemente innerhalb des scroll-container
      scrollContainers.forEach((el) => {
        el.style.backgroundColor = newColor;
      });
    }

    // Spezialbehandlung für Klein-Hero-Bereich
    if (kleinHeroAnimations.length > 0) {
      // Hide all klein-hero animations
      kleinHeroAnimations.forEach((anim) => (anim.style.display = "none"));

      // Select random animation for klein-hero
      const randomIndex = Math.floor(Math.random() * kleinHeroAnimations.length);
      const selectedAnimation = kleinHeroAnimations[randomIndex];
      selectedAnimation.style.display = "grid";

      // Neue Farbe wählen - immer von der letzten Farbe auf der Seite abgrenzen
      const lastUsedOnPage =
        usedColorsOnThisPage.length > 0
          ? usedColorsOnThisPage[usedColorsOnThisPage.length - 1]
          : lastUsedColors.general;
      const newColor = getRandomColor(colors, lastUsedOnPage);

      lastUsedColors.kleinHero = newColor;
      lastUsedColors.general = newColor;
      usedColorsOnThisPage.push(newColor);

      // Setzt die Farbe für die ausgewählte Klein-Hero-Animation
      applyColorsToSection(selectedAnimation, [newColor]);
    }

    // Spezialbehandlung für Textopening-Bereich
    if (textopeningAnimations.length > 0) {
      // Hide all textopening animations
      textopeningAnimations.forEach((anim) => (anim.style.display = "none"));

      // Select random animation for textopening
      const randomIndex = Math.floor(Math.random() * textopeningAnimations.length);
      const selectedAnimation = textopeningAnimations[randomIndex];
      selectedAnimation.style.display = "grid";

      // Neue Farbe wählen - immer von der letzten Farbe auf der Seite abgrenzen
      const lastUsedOnPage =
        usedColorsOnThisPage.length > 0
          ? usedColorsOnThisPage[usedColorsOnThisPage.length - 1]
          : lastUsedColors.general;
      const newColor = getRandomColor(colors, lastUsedOnPage);

      lastUsedColors.textopening = newColor;
      lastUsedColors.general = newColor;
      usedColorsOnThisPage.push(newColor);

      // Setzt die Farbe für die ausgewählte Textopening-Animation
      applyColorsToSection(selectedAnimation, [newColor]);
    }

    // Andere .random-bg Elemente behandeln (alle sichtbar lassen)
    otherAnimations.forEach((animation) => {
      animation.style.display = "grid"; // Sicherstellen, dass alle sichtbar sind

      // Neue Farbe wählen - immer von der letzten Farbe auf der Seite abgrenzen
      const lastUsedOnPage =
        usedColorsOnThisPage.length > 0
          ? usedColorsOnThisPage[usedColorsOnThisPage.length - 1]
          : lastUsedColors.general;
      const newColor = getRandomColor(colors, lastUsedOnPage);

      usedColorsOnThisPage.push(newColor);
      lastUsedColors.general = newColor;

      applyColorsToSection(animation, [newColor]);
    });

    // 4. Normale random bg-colors behandeln (nicht in bereits behandelten Containern)
    if (bgColors.length > 0) {
      const remainingBgColors = Array.from(bgColors).filter(
        (el) => !el.closest(".scroll-container"),
      );

      if (remainingBgColors.length > 0) {
        // Neue Farbe wählen - immer von der letzten Farbe auf der Seite abgrenzen
        const lastUsedOnPage =
          usedColorsOnThisPage.length > 0
            ? usedColorsOnThisPage[usedColorsOnThisPage.length - 1]
            : lastUsedColors.general;
        const newColor = getRandomColor(colors, lastUsedOnPage);

        lastUsedColors.general = newColor;

        remainingBgColors.forEach((el) => {
          el.style.backgroundColor = newColor;
        });
      }
    }
  }

  // Hilfsfunktion, um Farben auf ein bestimmtes Element anzuwenden
  function applyColorsToSection(section, colors) {
    // Verwende die übergebene Farbe
    const clipPathColor = colors[0];

    // Finde alle clip path Elemente in dieser Section
    const clipPathElements = section.querySelectorAll("div[class*='before:bg-random']");

    // Die gleiche Farbe auf alle clip path Elemente in dieser Section anwenden
    clipPathElements.forEach((element) => {
      element.style.setProperty("--clip-path-color", clipPathColor);
    });

    // GSAP animationen nur wenn sichtbar
    if (section.style.display !== "none") {
      // Klassen für die Animationen
      const animClasses = [
        { selector: ".oben", clipPath: "inset(100% 0 0 0)" },
        { selector: ".unten", clipPath: "inset(0 0 100% 0)" },
        { selector: ".rechts", clipPath: "inset(0 100% 0 0)" },
        { selector: ".links", clipPath: "inset(0 0 0 100%)" },
      ];

      // Animationen auf Elemente innerhalb dieser Section anwenden
      animClasses.forEach((anim) => {
        const elements = section.querySelectorAll(anim.selector);
        if (!elements || elements.length === 0) return;

        gsap.from(Array.from(elements), {
          duration: 1,
          clipPath: anim.clipPath,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
      });
    }
  }

  // Initial execution
  randomizeBgColor();
});

// Separate ScrollSmoother initialization
document.addEventListener("DOMContentLoaded", function () {
  if (
    typeof gsap === "undefined" ||
    typeof ScrollTrigger === "undefined" ||
    typeof ScrollSmoother === "undefined"
  ) {
    console.error("GSAP, ScrollTrigger oder ScrollSmoother nicht geladen");
    return;
  }

  // Register plugins
  gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

  // Initialize ScrollSmoother for all pages
  if (document.querySelector("#smooth-wrapper") && document.querySelector("#smooth-content")) {
    // Nur auf Desktop ohne Touch aktivieren, um native Momentum-Scroll auf Mobile zu erhalten
    const isTouch =
      "ontouchstart" in window ||
      (navigator && (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0));
    const isDesktop = window.matchMedia && window.matchMedia("(min-width: 1024px)").matches;

    if (isDesktop && !isTouch) {
      const smoother = ScrollSmoother.create({
        wrapper: "#smooth-wrapper",
        content: "#smooth-content",
        smooth: 0.8,
        effects: false,
        normalizeScroll: true,
        ignoreMobileResize: true,
        fastScrollEnd: true,
        preventOverlaps: true,
      });
    }
  }
});

// Your existing scroll container code (with ScrollSmoother initialization removed)
// Erweiterte Version Ihres StopScroller-Codes mit Punkt-Indikator
document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    console.error("GSAP oder ScrollTrigger nicht geladen");
    return;
  }

  // DOM elements
  const container = document.querySelector(".scroll-container");
  const imageScroll = document.querySelector(".image-scroll");
  const contentContainer = document.getElementById("dynamic-content-container");

  if (!container || !imageScroll || !contentContainer) {
    return;
  }

  // StopScroller nur auf Desktop initialisieren, da das Grid auf Mobile ausgeblendet ist
  // und die Trigger auf versteckten Elementen zu fehlerhaftem Verhalten führen können
  const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
  if (!isDesktop) {
    return;
  }

  // Bilder cachen
  const images = gsap.utils.toArray(".image-scroll img");
  if (images.length === 0) {
    console.error("Keine Bilder gefunden");
    return;
  }

  // Bild-Preloading und Lade-Attribute setzen, um sporadisches Nichtladen zu vermeiden
  try {
    images.forEach((img) => {
      // Erzwinge frühes Laden der StopScroller-Bilder
      img.setAttribute("loading", "eager");
      img.setAttribute("decoding", "async");
      // Optional: hilft bei decode() in manchen Browsern
      if (!img.getAttribute("crossorigin")) {
        img.setAttribute("crossorigin", "anonymous");
      }

      // Fehler-Retry bei Ladeproblemen
      img.dataset.retryCount = "0";
      img.addEventListener("error", () => {
        const count = parseInt(img.dataset.retryCount || "0", 10);
        if (count >= 3) return;
        img.dataset.retryCount = String(count + 1);
        const src = img.getAttribute("src");
        if (!src) return;
        const url = new URL(src, window.location.href);
        url.searchParams.set("rb", `${Date.now()}-${count}`);
        // kleiner Delay vor Retry
        setTimeout(
          () => {
            img.src = url.toString();
          },
          200 * (count + 1),
        );
      });
    });

    // Preload alle Bildquellen explizit
    const preloaders = [];
    images.forEach((img) => {
      const src = img.getAttribute("src");
      if (src) {
        const pre = new Image();
        pre.decoding = "async";
        pre.src = src;
        preloaders.push(pre);
      }
    });

    // Head-Preloads ergänzen (erzwingt frühe Anfragen durch den Browser)
    const head = document.head || document.getElementsByTagName("head")[0];
    images.forEach((img) => {
      const src = img.getAttribute("src");
      if (!src) return;
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = src;
      link.crossOrigin = "anonymous";
      head.appendChild(link);
    });

    // Zusätzliche Absicherung: decode() und Retry-Strategie
    function ensureDecoded(img, attempt = 0) {
      if (!img) return;
      if (img.complete && img.naturalWidth > 0) return;
      const maxAttempts = 3;
      try {
        if (img.decode) {
          img
            .decode()
            .catch(() => {})
            .finally(() => {
              if (!img.complete || img.naturalWidth === 0) {
                if (attempt < maxAttempts) {
                  const src = img.getAttribute("src");
                  if (src) {
                    const url = new URL(src, window.location.href);
                    url.searchParams.set("cb", `${Date.now()}-${attempt}`);
                    img.src = url.toString();
                  }
                  setTimeout(() => ensureDecoded(img, attempt + 1), 400 * (attempt + 1));
                }
              }
            });
        }
      } catch {}
    }

    setTimeout(() => {
      images.forEach((img) => ensureDecoded(img));
    }, 500);
  } catch (e) {
    console.warn("Preloading Hinweis:", e);
  }

  // Punkt-Indikator erstellen
  const createIndicator = () => {
    // Prüfen ob bereits vorhanden
    let indicator = document.querySelector(".scroll-indicator");
    if (indicator) {
      indicator.remove();
    }

    // Neuen Indikator erstellen
    indicator = document.createElement("div");
    indicator.className = "scroll-indicator";
    indicator.style.cssText = `
      position: fixed;
      left: 24px;
      bottom: -8px;
      transform: translateY(-50%);
      z-index: 1000;
      display: flex;
      flex-direction: column;
      gap: 12px;
      pointer-events: none;
    `;

    // Punkte für jedes Bild erstellen
    images.forEach((_, index) => {
      const dot = document.createElement("div");
      dot.className = `indicator-dot dot-${index}`;
      dot.style.cssText = `
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      cursor: pointer;
      pointer-events: auto;
    `;

      // Click Event für jeden Dot
      dot.addEventListener("click", () => {
        scrollToImage(index);
      });

      // Hover-Effekt
      dot.addEventListener("mouseenter", () => {
        if (!dot.classList.contains("active")) {
          dot.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
          dot.style.transform = "scale(1.1)";
        }
      });

      dot.addEventListener("mouseleave", () => {
        if (!dot.classList.contains("active")) {
          dot.style.backgroundColor = "rgba(0, 0, 0, 0.2)";
          dot.style.transform = "scale(1)";
        }
      });

      // Erster Punkt ist aktiv
      if (index === 0) {
        dot.style.backgroundColor = "rgba(0, 0, 0, 1.0)";
        dot.style.transform = "scale(1.2)";
        dot.classList.add("active");
      }

      indicator.appendChild(dot);
    });

    // Indikator zum Container hinzufügen
    container.appendChild(indicator);
    return indicator;
  };
  const scrollToImage = (targetIndex) => {
    if (targetIndex < 0 || targetIndex >= images.length) return;

    const viewportHeight =
      window.innerWidth < 768 ? Math.ceil(window.innerHeight) / 2 : Math.ceil(window.innerHeight);

    const totalHeight = images.length * viewportHeight;
    const maxIndex = images.length - 1;

    // Find the ScrollTrigger for the container
    const scrollTrigger = ScrollTrigger.getAll().find((trigger) => trigger.trigger === container);

    if (scrollTrigger) {
      const triggerStart = scrollTrigger.start;
      const triggerEnd = scrollTrigger.end;
      const scrollRange = triggerEnd - triggerStart;

      // Calculate target progress differently for the last element
      let targetProgress;
      if (targetIndex === maxIndex) {
        // For the last element, use 100% progress
        targetProgress = 1;
      } else {
        // For all other elements, distribute evenly across the available range
        // Use 0.7 as the cutoff point (matching your handleUpdate logic)
        targetProgress = (targetIndex / maxIndex) * 0.7;
      }

      const targetScrollPosition = triggerStart + targetProgress * scrollRange;

      // Debug logging (remove in production)
      console.log(`Scrolling to index ${targetIndex}:`, {
        targetProgress,
        targetScrollPosition,
        triggerStart,
        triggerEnd,
      });

      // Smoothly scroll to target position
      if (window.ScrollSmoother && window.ScrollSmoother.get()) {
        window.ScrollSmoother.get().scrollTo(targetScrollPosition, true, "power2.out");
      } else {
        window.scrollTo({
          top: targetScrollPosition,
          behavior: "smooth",
        });
      }
    }
  };

  // Indikator aktualisieren
  const updateIndicator = (activeIndex) => {
    const dots = document.querySelectorAll(".indicator-dot");

    dots.forEach((dot, index) => {
      // Entferne active Klasse von allen
      dot.classList.remove("active");

      if (index === activeIndex) {
        // Aktiver Punkt
        dot.style.backgroundColor = "rgba(0, 0, 0, 1.0)";
        dot.style.transform = "scale(1.2)";
        dot.classList.add("active");
      } else if (index < activeIndex) {
        // Bereits durchlaufene Punkte
        dot.style.backgroundColor = "rgba(0, 0, 0, 0.4)";
        dot.style.transform = "scale(1)";
      } else {
        // Noch nicht erreichte Punkte
        dot.style.backgroundColor = "rgba(0, 0, 0, 0.2)";
        dot.style.transform = "scale(1)";
      }
    });
  };

  // Variablen für Zustandsverfolgung
  let animation;
  let currentContentIndex = -1;
  let resizeTimeout;
  let isAnimating = false;

  // Inhalts-Daten einmalig parsen und cachen
  let allContents = [];
  try {
    allContents = contentContainer.dataset.contents
      ? JSON.parse(contentContainer.dataset.contents)
      : [];
  } catch (e) {
    console.error("Fehler beim Parsen der Content-Daten:", e);
  }

  // Content-Update-Funktion (erweitert)
  const updateContent = (index) => {
    if (index === currentContentIndex || !allContents[index] || isAnimating) return;

    isAnimating = true;
    currentContentIndex = index;

    // Indikator aktualisieren
    updateIndicator(index);

    const content = allContents[index];

    const truncateText = (text) => {
      if (!text) return "";
      const isMobile = window.innerWidth < 768;
      const maxLength = isMobile ? 100 : 250;
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    };

    const htmlContent = `<div>
      <h5 class="pb-[1rem]">${content.titel || ""}</h5>
      <h4 class="pb-[40px]">${truncateText(content.text || "")}</h4></div>
      ${
        content.link && content.link.url && content.link.title
          ? `<a class="custom-btn-black w-fit" data-content-index="${currentContentIndex}" href="${content.link.url}">${content.link.title}</a>`
          : content.ersatztext
            ? `<p class="md:text-[22px] text-[18px] leading-[24px]">${content.ersatztext}</p>`
            : ""
      }
    `;

    requestAnimationFrame(() => {
      contentContainer.innerHTML = htmlContent;

      attachHoverEvents();

      gsap.fromTo(
        contentContainer,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.3,
          ease: "power2.out",
          onComplete: () => {
            isAnimating = false;
          },
        },
      );
    });
  };

  // Setup Scroll Animation (erweitert)
  const setupScrollAnimation = () => {
    // Indikator erstellen
    createIndicator();

    const viewportHeight =
      window.innerWidth < 768 ? Math.ceil(window.innerHeight) / 2 : Math.ceil(window.innerHeight);
    const totalHeight = images.length * viewportHeight;

    const imgCount = images.length;
    for (let i = 0; i < imgCount; i++) {
      const img = images[i];
      Object.assign(img.style, {
        height: `${viewportHeight}px`,
        display: "block",
        margin: "0",
        padding: "0",
        willChange: "transform",
      });
    }

    imageScroll.style.height = `${totalHeight}px`;
    imageScroll.style.willChange = "transform";
    container.style.willChange = "transform";

    const handleUpdate = (self) => {
      const normalizedProgress = self.progress > 1 ? 1 : self.progress < 0 ? 0 : self.progress;
      const maxIndex = images.length - 1;

      let imageIndex;

      // More precise index calculation
      if (normalizedProgress >= 0.99) {
        // If we're at the very end, definitely show the last image
        imageIndex = maxIndex;
      } else if (normalizedProgress < 0.7) {
        // Before the 70% cutoff, distribute evenly
        imageIndex = Math.round((normalizedProgress * maxIndex) / 0.7);
      } else {
        // After 70%, show the last image
        imageIndex = maxIndex;
      }

      // Ensure imageIndex is within bounds
      imageIndex = Math.max(0, Math.min(maxIndex, imageIndex));

      const snapPosition = (imageIndex / maxIndex) * (totalHeight - viewportHeight);
      if (imageScroll) {
        gsap.to(imageScroll, {
          y: -snapPosition,
          duration: 0.8,
          ease: "power2.out",
        });
      }

      // Lade-Prioritäten dynamisch setzen (aktuelle + nächste Bild höher priorisieren)
      try {
        images.forEach((img, idx) => {
          if ("fetchPriority" in img) {
            img.fetchPriority = idx === imageIndex || idx === imageIndex + 1 ? "high" : "low";
          }
        });
      } catch {}

      if (imageIndex !== currentContentIndex) {
        updateContent(imageIndex);
      }
    };

    if (!imageScroll) return;
    animation = gsap.to(imageScroll, {
      y: () => -totalHeight + viewportHeight,
      ease: "none",
      scrollTrigger: {
        trigger: container,
        start: "top top",
        end: () => `+=${totalHeight - viewportHeight + viewportHeight}`,
        pin: true,
        scrub: false,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        refreshPriority: 1,
        fastScrollEnd: true,
        preventOverlaps: true,
        onUpdate: handleUpdate,
      },
    });

    return animation;
  };

  // Resize-Handler (erweitert)
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      setupScrollAnimation();
      ScrollTrigger.refresh();
    }, 200);
  };

  // Initialisierung
  const init = () => {
    updateContent(0);
    setupScrollAnimation();
    window.addEventListener("resize", handleResize, { passive: true });

    window.addEventListener(
      "load",
      () => {
        ScrollTrigger.refresh(true);
        updateContent(0);
      },
      { once: true },
    );
  };

  init();
});

// CSS für bessere Sichtbarkeit der Indikatoren (optional)
const addIndicatorStyles = () => {
  const style = document.createElement("style");
  style.textContent = `
    .scroll-indicator {
      /* Responsive Anpassungen */
    }
    
    @media (max-width: 768px) {
      .scroll-indicator {
        left: 16px !important;
        gap: 8px !important;
      }
      
      .indicator-dot {
        width: 6px !important;
        height: 6px !important;
      }
    }
    
    /* Hover-Effekt für Desktop */
    @media (min-width: 769px) {
      .scroll-indicator:hover .indicator-dot {
        transform: scale(1.1) !important;
      }
    }
  `;
  document.head.appendChild(style);
};

// Styles hinzufügen
document.addEventListener("DOMContentLoaded", addIndicatorStyles);
// Initialize Flickity (carousel)
document.addEventListener("DOMContentLoaded", function () {
  const bilderCarousels = document.querySelectorAll(".bilderCarousel");

  if (bilderCarousels.length) {
    bilderCarousels.forEach((carousel) => {
      new Flickity(carousel, {
        // options
        cellAlign: "left",
        wrapAround: true,
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        autoPlay: 4000,
        pauseAutoPlayOnHover: false,
        draggable: true,
      });
    });
  }
});

// Sticky-Titel mit GSAP ScrollTrigger für Kompatibilität mit ScrollSmoother
document.addEventListener("DOMContentLoaded", function () {
  // Prüfe, ob sticky-titel-Elemente vorhanden sind
  const stickyTitels = document.querySelectorAll(".sticky-titel");

  // Funktion, um zu prüfen, ob wir uns auf einem mobilen Gerät befinden
  const isMobileDevice = () => window.innerWidth < 1280; // 1280px als Breakpoint für Mobile

  // Funktion zum Aktualisieren der Sticky-Funktionalität
  function updateStickyBehavior() {
    // Prüfe auf mobile Ansicht
    if (isMobileDevice()) {
      // Auf Mobilgeräten: Entferne alle ScrollTrigger und stelle Titel auf relative Position
      stickyTitels.forEach((titel) => {
        // Deaktiviere jegliche aktive ScrollTrigger für diesen Titel
        const existingTriggers = ScrollTrigger.getAll().filter(
          (trigger) =>
            trigger.vars.trigger === titel.closest(".sticky-titel-block") ||
            trigger.vars.pin === titel,
        );

        existingTriggers.forEach((trigger) => trigger.kill());

        // Setze Titel auf relative Position
        titel.style.position = "relative";
        titel.style.top = "auto";
        titel.style.transform = "none";
        titel.style.opacity = "1";
        titel.style.visibility = "visible";
      });
    } else {
      // Auf Desktop: Initialisiere die ScrollTrigger
      initStickyTitels();
    }
  }

  // Funktion zur Initialisierung der Sticky-Titel
  function initStickyTitels() {
    if (stickyTitels.length === 0) return;

    // Bestehende Trigger entfernen
    ScrollTrigger.getAll().forEach((trigger) => {
      if (trigger.vars.id && trigger.vars.id.includes("sticky-titel")) {
        trigger.kill();
      }
    });

    stickyTitels.forEach((titel) => {
      // Finde den übergeordneten sticky-titel-block
      const stickyBlock = titel.closest(".sticky-titel-block");
      const stickyBlockLong = titel.closest(".sticky-titel-block-long");

      if (stickyBlock) {
        // Stelle sicher, dass der Titel im Desktop-Modus richtig positioniert ist
        titel.style.position = "";
        titel.style.top = "";
        titel.style.transform = "";

        // Berechne die Höhe des Titels für den Offset
        const titelHeight = titel.offsetHeight;

        // Erster ScrollTrigger für das Pinnen
        const pinTrigger = ScrollTrigger.create({
          id: `sticky-titel-pin-${Math.random()}`,
          trigger: stickyBlock,
          start: "top top",
          endTrigger: stickyBlock,
          end: `bottom-=${titelHeight + 10} top`,
          pin: titel,
          pinSpacing: false,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        });

        // Zweiter ScrollTrigger für das Ausblenden wenn 30% des Blocks über den Viewport hinaus gescrollt sind
        ScrollTrigger.create({
          id: `sticky-titel-fade-${Math.random()}`,
          trigger: stickyBlock,
          start: "top -30%",
          end: "top -31%",
          onEnter: () => {
            // Block ist zu mehr als 30% außerhalb des Viewports nach oben
            gsap.to(titel, {
              autoAlpha: 0,
              duration: 0.3,
              ease: "power2.out",
            });
          },
          onEnterBack: () => {
            // Block kommt wieder in den Sichtbereich
            gsap.to(titel, {
              autoAlpha: 1,
              duration: 0.3,
              ease: "power2.in",
            });
          },
          invalidateOnRefresh: true,
        });
      } else if (stickyBlockLong) {
        // Für den langen Block
        titel.style.position = "";
        titel.style.top = "";
        titel.style.transform = "";

        const titelHeight = titel.offsetHeight;

        // Erster ScrollTrigger für das Pinnen
        const pinTriggerLong = ScrollTrigger.create({
          id: `sticky-titel-pin-${Math.random()}`,
          trigger: stickyBlockLong,
          start: "top top",
          endTrigger: stickyBlockLong,
          end: `bottom-=${titelHeight + 10} top`,
          pin: titel,
          pinSpacing: false,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        });

        ScrollTrigger.create({
          id: `sticky-titel-fade-${Math.random()}`,
          trigger: stickyBlockLong,
          start: () => `top -${stickyBlockLong.offsetHeight * 0.8}px`,
          end: () => `top -${stickyBlockLong.offsetHeight * 0.81}px`,
          onEnter: () => {
            // Block ist zu mehr als 30% außerhalb des Viewports nach oben
            gsap.to(titel, {
              autoAlpha: 0,
              duration: 0.3,
              ease: "power2.out",
            });
          },
          onEnterBack: () => {
            // Block kommt wieder in den Sichtbereich
            gsap.to(titel, {
              autoAlpha: 1,
              duration: 0.3,
              ease: "power2.in",
            });
          },
          invalidateOnRefresh: true,
        });
      }
    });
  }

  // Initial setup
  updateStickyBehavior();

  // Event Listener für Bildschirmgrößenänderungen
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateStickyBehavior, 250); // Debounce zur Leistungsoptimierung
  });
});

// Aktualisiere die Funktion zur dynamischen Größenanpassung der Dots
function updateFlickityDotSizes() {
  // Alle Karussells durchgehen
  const carousels = document.querySelectorAll(".bilderCarousel, .newsCarousel, .zitat-carousel");

  carousels.forEach((carousel) => {
    const dots = carousel.querySelectorAll(".flickity-page-dots .dot");
    const selectedIndex = Array.from(dots).findIndex((dot) =>
      dot.classList.contains("is-selected"),
    );

    if (selectedIndex === -1) return; // Kein ausgewählter Dot gefunden

    dots.forEach((dot, index) => {
      // Wenn es der ausgewählte Dot ist, maximale Größe
      if (index === selectedIndex) {
        dot.style.width = "16px";
        dot.style.height = "16px";
        return;
      }

      // Abstand zum ausgewählten Dot berechnen
      const distance = Math.abs(index - selectedIndex);

      // Verbesserte Größenberechnung mit sanfterer Abstufung
      let size;

      switch (distance) {
        case 1: // Direkte Nachbarn
          size = 10;
          break;
        case 2:
          size = 8;
          break;
        case 3:
          size = 7;
          break;
        default: // Alles darüber
          size = 6; // Minimalgröße
      }

      // Größe anwenden
      dot.style.width = `${size}px`;
      dot.style.height = `${size}px`;
    });
  });
}

// Führe die Funktion nach dem Laden der Seite aus
document.addEventListener("DOMContentLoaded", function () {
  // Warten auf Flickity-Initialisierung
  setTimeout(() => {
    updateFlickityDotSizes();

    // Bei jedem Slide-Wechsel aktualisieren
    const carousels = document.querySelectorAll(".bilderCarousel, .newsCarousel, .zitat-carousel");
    carousels.forEach((carousel) => {
      const flkty = Flickity.data(carousel);
      if (flkty) {
        flkty.on("select", updateFlickityDotSizes);
      }
    });
  }, 100);
});

// Funktion zur Größenanpassung der Instagram Carousel Dots
function updateInstagramDotSizes() {
  // Alle Instagram Carousels durchgehen
  const instaDotsContainers = document.querySelectorAll(".sbi-owl-dots");

  instaDotsContainers.forEach((container) => {
    const dots = container.querySelectorAll(".sbi-owl-dot");
    // Finde den aktiven Dot
    const selectedIndex = Array.from(dots).findIndex((dot) => dot.classList.contains("active"));

    if (selectedIndex === -1) return; // Kein ausgewählter Dot gefunden

    dots.forEach((dot, index) => {
      // Span-Element für die Größenänderung auswählen
      const span = dot.querySelector("span");
      if (!span) return;

      // Wenn es der ausgewählte Dot ist, maximale Größe
      if (index === selectedIndex) {
        span.style.width = "16px";
        span.style.height = "16px";
        return;
      }

      // Abstand zum ausgewählten Dot berechnen
      const distance = Math.abs(index - selectedIndex);

      // Gleiche Größenberechnung wie bei bilderCarousel
      let size;
      switch (distance) {
        case 1: // Direkte Nachbarn
          size = 10;
          break;
        case 2:
          size = 8;
          break;
        case 3:
          size = 7;
          break;
        default: // Alles darüber
          size = 6; // Minimalgröße
      }

      // Größe anwenden
      span.style.width = `${size}px`;
      span.style.height = `${size}px`;
    });
  });
}

// Event-Listener für Instagram-Feed
document.addEventListener("DOMContentLoaded", function () {
  // Warte auf das Laden des Instagram-Feeds
  const checkInstagramFeed = setInterval(() => {
    const instaCarousel = document.querySelector(".sbi-owl-dots");
    if (instaCarousel) {
      clearInterval(checkInstagramFeed);

      // Initial anwenden
      updateInstagramDotSizes();

      // MutationObserver einrichten, um Änderungen im Instagram Feed zu überwachen
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // Wenn Klassen geändert wurden, könnte sich der aktive Dot geändert haben
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            updateInstagramDotSizes();
          }
        });
      });

      // Beobachte alle Dots auf Klassenänderungen
      const dots = document.querySelectorAll(".sbi-owl-dot");
      dots.forEach((dot) => {
        observer.observe(dot, { attributes: true });
      });
    }
  }, 500);
});

// Optional: CSS-Anpassungen für die Dots
document.addEventListener("DOMContentLoaded", function () {
  // Erstelle ein Style-Element
  const style = document.createElement("style");
  style.textContent = `
    .sbi-owl-dots {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-top: 20px;
    }
    .sbi-owl-dot span {
      display: block;
      border-radius: 50%;
      background-color: #999;
      transition: all 0.3s ease;
    }
    .sbi-owl-dot.active span {
      background-color: #333;
    }
  `;
  document.head.appendChild(style);
});

// Back to Top Button
document.addEventListener("DOMContentLoaded", function () {
  const backToTopButton = document.getElementById("back-to-top");

  if (backToTopButton) {
    // Button anzeigen/verstecken basierend auf Scroll-Position
    window.addEventListener("scroll", function () {
      if (window.pageYOffset > 300) {
        backToTopButton.classList.add("visible");
      } else {
        backToTopButton.classList.remove("visible");
      }
    });

    // Smooth Scroll nach oben
    backToTopButton.addEventListener("click", function (e) {
      e.preventDefault();

      // Wenn GSAP ScrollSmoother aktiv ist
      if (window.ScrollSmoother && window.ScrollSmoother.get()) {
        window.ScrollSmoother.get().scrollTo(0, true);
      } else {
        // Fallback für Browser ohne ScrollSmoother
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    });
  }
});

// Synchronisiere Hover-Effekte zwischen Bild und Link im Teaser-Block
document.addEventListener("DOMContentLoaded", function () {
  // Funktion zum Finden des zugehörigen Elements im selben Teaser-Block
  function findRelatedElement(element, className, searchUp = "section") {
    // Finde den umschließenden Teaser-Block
    const container = element.closest(searchUp);
    if (!container) return null;

    // Finde das zugehörige Element im selben Container
    return container.querySelector(className);
  }

  // Alle Links mit hover-link Klasse
  const hoverLinks = document.querySelectorAll(".hover-link");

  // Event-Listener für jeden Link
  hoverLinks.forEach((link) => {
    // Finde das zugehörige Bild
    const img = findRelatedElement(link, ".hover-img");
    if (!img) return;

    // Link hover aktiviert auch Bild-Zoom
    link.addEventListener("mouseenter", () => {
      img.classList.add("scale-105");
    });

    link.addEventListener("mouseleave", () => {
      // Nur entfernen, wenn nicht gerade über dem Bild gehovert wird
      if (!img.matches(":hover")) {
        img.classList.remove("scale-105");
      }
    });
  });

  // Alle Bilder mit hover-img Klasse
  const hoverImgs = document.querySelectorAll(".hover-img");

  // Event-Listener für jedes Bild
  hoverImgs.forEach((img) => {
    // Finde den zugehörigen Link
    const link = findRelatedElement(img, ".hover-link");
    if (!link) return;

    // Original hover:scale-105 von Tailwind durch JS steuern
    img.classList.remove("hover:scale-105");

    // Bild hover aktiviert auch Link-Unterstreichung
    img.addEventListener("mouseenter", () => {
      // Manuell hover simulieren für den Link
      link.classList.add("hovered");
      img.classList.add("scale-105");
    });

    img.addEventListener("mouseleave", () => {
      // Nur entfernen, wenn nicht gerade über dem Link gehovert wird
      if (!link.matches(":hover")) {
        link.classList.remove("hovered");
        img.classList.remove("scale-105");
      }
    });
  });
});

// Startseite logo animation
let logoScrollTriggers = []; // Array um Logo-Trigger zu verfolgen

document.addEventListener("DOMContentLoaded", function () {
  initLogoAnimation();
});

function initLogoAnimation() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    console.error("GSAP oder ScrollTrigger nicht geladen");
    return;
  }
  // Nur auf Desktop: nativen Scroll-Restore deaktivieren, da GSAP die Position verwaltet.
  // Auf Mobile native Browser-Verwaltung behalten, um iOS-Scroll-Bugs zu vermeiden.
  const isDesktopForRestoration =
    window.matchMedia && window.matchMedia("(min-width: 1024px)").matches;
  if (isDesktopForRestoration && "scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
  // Das Logo-Element
  const logo = document.querySelector(".animatedlogo img");
  if (!logo) return;

  // Ursprüngliche Logo-Dimensionen speichern BEVOR ScrollTrigger sie ändert
  const originalHeight = logo.offsetHeight || logo.naturalHeight || 120;
  const originalWidth = logo.offsetWidth || logo.naturalWidth || "auto";

  // In globalen Variablen speichern für späteren Zugriff
  window.logoOriginalDimensions = {
    height: originalHeight,
    width: originalWidth,
  };

  // Bei Hash-Navigation: Nur Logo vorbereiten, NICHT scrollen
  if (window.location.hash) {
    setTimeout(() => {
      // Logo auf korrekte Ausgangsgröße setzen ohne Scroll-Position zu ändern
      prepareLogoForHashNavigation();
    }, 100);
  }

  createLogoScrollTriggers(logo);
}

function createLogoScrollTriggers(logo) {
  // Cleanup
  logoScrollTriggers.forEach((trigger) => {
    try {
      trigger.kill();
    } catch {}
  });
  logoScrollTriggers = [];

  const isMobile = () => window.innerWidth < 1024;

  // Pin-Trigger nur auf Desktop: Auf Mobile kämpft der GSAP-Pin-Mechanismus
  // gegen iOS-Momentum-Scroll → Scroll-Stutter und falsche Logo-Position beim
  // Zurückscrollern. Ohne Pin fällt auch der pin-spacer-Wrapper weg.
  if (!isMobile()) {
    const pinTrigger = ScrollTrigger.create({
      trigger: logo,
      start: "top top+=24px",
      scrub: true,
      pin: true,
      pinSpacing: false,
    });
    logoScrollTriggers.push(pinTrigger);
  }

  const heroEl = document.querySelector(".hero");
  if (heroEl) {
    const origH =
      (window.logoOriginalDimensions && window.logoOriginalDimensions.height) ||
      logo.offsetHeight ||
      240;
    const smallTargetH = 90;
    const smallScale = Math.min(0.95, Math.max(0.1, smallTargetH / origH));

    // Timeline mit ZWEI Phasen über den gesamten Hero:
    //   0 - 50% scroll: Logo schrumpft von origH/scale1 -> 90px/smallScale
    //   50 - 100% scroll: Logo bleibt klein (hold)
    // Vorteile bei schnellem Scrollen:
    //  - Der Scrub-Bereich ist 100vh statt 50vh -> größerer Buffer
    //  - Past-State wird automatisch gehalten ohne separaten persistTrigger
    //  - Beim Reverse-Scroll greift der Tween zuverlässig wieder
    // refreshPriority: 0 ist explizit niedriger als StopScroll (1) -> Logo refresht
    // NACH StopScroll, sodass das Layout dann stabil ist.
    const sizeTl = gsap.timeline({
      scrollTrigger: {
        trigger: heroEl,
        start: "top top",
        end: "bottom top",
        scrub: true,
        invalidateOnRefresh: true,
        fastScrollEnd: true,
        refreshPriority: -1,
      },
    });

    if (isMobile()) {
      // transformOrigin "center center": Logo schrumpft gleichmässig von der Mitte,
      // passend zum flex-items-center-Kontext des Hero-Containers.
      sizeTl
        .fromTo(
          logo,
          { scale: 1, transformOrigin: "center center" },
          {
            scale: smallScale,
            transformOrigin: "center center",
            duration: 0.5,
            ease: "none",
          },
        )
        .to(logo, {
          scale: smallScale,
          transformOrigin: "center center",
          duration: 0.5,
          ease: "none",
        });
    } else {
      sizeTl
        .fromTo(logo, { height: origH }, { height: smallTargetH, duration: 0.5, ease: "none" })
        .to(logo, { height: smallTargetH, duration: 0.5, ease: "none" });
    }

    if (sizeTl.scrollTrigger) {
      logoScrollTriggers.push(sizeTl.scrollTrigger);
    }
  } else {
    // Fallback ohne .hero
    const fallbackTl = gsap.timeline({
      scrollTrigger: {
        trigger: document.body,
        start: "top top",
        end: "+=400 top",
        scrub: true,
        invalidateOnRefresh: true,
        fastScrollEnd: true,
      },
    });
    fallbackTl
      .fromTo(
        logo,
        { height: logo.offsetHeight || 240 },
        { height: 90, duration: 0.5, ease: "none" },
      )
      .to(logo, { height: 90, duration: 0.5, ease: "none" });

    if (fallbackTl.scrollTrigger) {
      logoScrollTriggers.push(fallbackTl.scrollTrigger);
    }
  }

  try {
    ScrollTrigger.refresh(true);
  } catch {}

  // window.load: nochmal refreshen, NACHDEM der StopScroll
  // sein Layout etabliert hat. invalidateOnRefresh stellt sicher,
  // dass der from-Wert (origH) jetzt mit aktuellem Layout neu
  // gemessen wird.
  if (!window._logoLoadListenerAttached) {
    window._logoLoadListenerAttached = true;
    window.addEventListener(
      "load",
      () => {
        requestAnimationFrame(() => {
          try {
            ScrollTrigger.refresh(true);
          } catch {}
        });
        setTimeout(() => {
          try {
            ScrollTrigger.refresh(true);
          } catch {}
        }, 500);
      },
      { once: true },
    );
  }

  // Resize-Handler (unverändert)
  if (!window._logoResizeListenerAttached) {
    window._logoResizeListenerAttached = true;
    let _logoResizeTo;
    window.addEventListener(
      "resize",
      () => {
        clearTimeout(_logoResizeTo);
        _logoResizeTo = setTimeout(() => {
          logoScrollTriggers.forEach((t) => {
            try {
              t.kill();
            } catch {}
          });
          logoScrollTriggers = [];
          createLogoScrollTriggers(logo);
        }, 200);
      },
      { passive: true },
    );
  }
}

// Funktion um Logo für Hash-Navigation vorzubereiten (ohne Scroll-Position zu ändern)
function prepareLogoForHashNavigation() {
  try {
    const logo = document.querySelector(".animatedlogo img");
    if (!logo) return;

    // Funktion um Logo-Styles aggressiv zu überschreiben
    const forceLogoStyles = () => {
      // Alle GSAP-Properties entfernen
      gsap.set(logo, { clearProps: "all" });

      // Logo-Styles aggressiv überschreiben - alle problematischen Properties
      logo.style.setProperty("width", "auto", "important");
      logo.style.setProperty("height", "auto", "important");
      logo.style.setProperty("max-width", window.innerWidth < 768 ? "160px" : "420px", "important");
      logo.style.setProperty("max-height", "none", "important");
      logo.style.setProperty("transform", "none", "important");
      logo.style.setProperty("translate", "none", "important");
      logo.style.setProperty("inset", "auto", "important");
      logo.style.setProperty("margin", "0 auto", "important"); // Zentrieren!
      logo.style.setProperty("padding", "0", "important");
      logo.style.setProperty("position", "static", "important");
      logo.style.setProperty("top", "auto", "important");
      logo.style.setProperty("left", "auto", "important");
      logo.style.setProperty("right", "auto", "important");
      logo.style.setProperty("bottom", "auto", "important");
      logo.style.setProperty("display", "block", "important"); // Block für margin auto

      // CSS-Klassen setzen
      logo.className = "max-w-[160px] md:max-w-[420px] h-auto block mx-auto";

      // Reflow erzwingen
      logo.offsetHeight; // Trigger reflow

      // Pin-spacer auch zentrieren und reflow erzwingen
      const pinSpacer = logo.closest(".pin-spacer");
      if (pinSpacer) {
        pinSpacer.style.setProperty("text-align", "center", "important");
        pinSpacer.style.setProperty("display", "flex", "important");
        pinSpacer.style.setProperty("justify-content", "center", "important");
        pinSpacer.style.setProperty("align-items", "center", "important");
        pinSpacer.offsetHeight; // Trigger reflow
      }
    };

    // Initial Logo-Styles setzen
    forceLogoStyles();

    // Pin-Spacer anpassen falls vorhanden (nicht entfernen)
    const pinSpacer = logo.closest(".pin-spacer");
    if (pinSpacer) {
      // Funktion um Pin-Spacer-Styles aggressiv zu überschreiben
      const forcePinSpacerStyles = () => {
        const isMobile = window.innerWidth < 768;
        pinSpacer.style.setProperty("width", "auto", "important");
        pinSpacer.style.setProperty("height", "auto", "important");
        pinSpacer.style.setProperty("max-width", isMobile ? "160px" : "420px", "important");
        pinSpacer.style.setProperty("max-height", "none", "important");
      };

      // Initial setzen
      forcePinSpacerStyles();

      // Kontinuierlich beide überschreiben für 2 Sekunden
      const intervalId = setInterval(() => {
        forceLogoStyles();
        forcePinSpacerStyles();
      }, 50);
      setTimeout(() => clearInterval(intervalId), 2000);
    }
  } catch (e) {
    console.warn("Logo preparation:", e);
  }
}

function resetLogoAnimation() {
  try {
    const logo = document.querySelector(".animatedlogo img");
    if (!logo || !window.logoOriginalDimensions) return;

    // Alle GSAP-Eigenschaften und Transforms entfernen
    gsap.set(logo, { clearProps: "all" });

    // Logo explizit auf Original-Dimensionen setzen
    logo.style.cssText = `
      height: ${window.logoOriginalDimensions.height}px !important;
      width: ${
        window.logoOriginalDimensions.width === "auto"
          ? "auto"
          : window.logoOriginalDimensions.width + "px"
      } !important;
      max-width: none !important;
      max-height: none !important;
      transform: none !important;
    `;

    // Pin-Spacer entfernen falls vorhanden
    const pinSpacer = logo.closest(".pin-spacer");
    if (pinSpacer && pinSpacer.parentNode) {
      // Logo aus Pin-Spacer herausnehmen und zurück in Original-Parent
      const originalParent = pinSpacer.parentNode;
      originalParent.insertBefore(logo, pinSpacer);
      originalParent.removeChild(pinSpacer);
    }

    // Logo-ScrollTriggers komplett neu erstellen
    setTimeout(() => {
      createLogoScrollTriggers(logo);
      ScrollTrigger.refresh(true);
    }, 100);
  } catch (e) {
    console.warn("Logo reset:", e);
  }
}

// Funktion um Logo nach programmatischem Scroll zu korrigieren
function fixLogoSpacerAfterScroll() {
  try {
    const logo = document.querySelector(".animatedlogo img");
    if (!logo) return;

    // Aggressives Überschreiben der Logo-Styles (wiederholt kurzzeitig)
    const forceLogoStyles = () => {
      try {
        gsap.set(logo, { clearProps: "all" });
      } catch {}

      const isMobile = window.innerWidth < 768;
      logo.style.setProperty("width", "auto", "important");
      logo.style.setProperty("height", "auto", "important");
      logo.style.setProperty("max-width", isMobile ? "160px" : "420px", "important");
      logo.style.setProperty("max-height", "none", "important");
      logo.style.setProperty("transform", "none", "important");
      logo.style.setProperty("translate", "none", "important");
      logo.style.setProperty("inset", "auto", "important");
      logo.style.setProperty("margin", "0 auto", "important");
      logo.style.setProperty("padding", "0", "important");
      logo.style.setProperty("position", "static", "important");
      logo.style.setProperty("display", "block", "important");

      // Klassen sicherstellen
      logo.className = "max-w-[160px] md:max-w-[420px] h-auto block mx-auto";

      const pinSpacer = logo.closest(".pin-spacer");
      if (pinSpacer) {
        const forcePinSpacerStyles = () => {
          pinSpacer.style.setProperty("width", "auto", "important");
          pinSpacer.style.setProperty("height", "auto", "important");
          pinSpacer.style.setProperty("max-width", isMobile ? "160px" : "420px", "important");
          pinSpacer.style.setProperty("max-height", "none", "important");
          pinSpacer.style.setProperty("text-align", "center", "important");
          pinSpacer.style.setProperty("display", "flex", "important");
          pinSpacer.style.setProperty("justify-content", "center", "important");
          pinSpacer.style.setProperty("align-items", "center", "important");
        };
        forcePinSpacerStyles();

        // MutationObserver für Pin-Spacer
        try {
          const observer = new MutationObserver(() => forcePinSpacerStyles());
          observer.observe(pinSpacer, { attributes: true, attributeFilter: ["style"] });
          setTimeout(() => observer.disconnect(), 3000);
        } catch {}
      }
    };

    // Mehrfach re-applizieren, falls GSAP noch schreibt
    const start = Date.now();
    const applyLoop = () => {
      forceLogoStyles();
      if (Date.now() - start < 1500) {
        setTimeout(applyLoop, 100);
      } else {
        // finaler Refresh
        try {
          ScrollTrigger.refresh(true);
        } catch {}
      }
    };
    setTimeout(applyLoop, 50);
  } catch (e) {
    console.warn("Logo spacer fix:", e);
  }
}

// Funktion, um die Hover-Event-Listener zu Buttons hinzuzufügen und Links auf Bilder anzuwenden
function attachHoverEvents() {
  // Links finden, die beim Hover Bilder zoomen sollen
  const zoomLinks = document.querySelectorAll("#dynamic-content-container .custom-btn-black");

  zoomLinks.forEach((link) => {
    // Content-Index aus dem Link holen
    const contentIndex = link.getAttribute("data-content-index");
    if (!contentIndex) return;

    // Entsprechendes Bild-Container finden (das übergeordnete div des Bildes)
    const targetImageContainer = document.querySelector(
      `.image-scroll img[data-content-index="${contentIndex}"]`,
    )?.parentElement;

    if (!targetImageContainer) return;

    // Entsprechendes Bild finden
    const targetImage = targetImageContainer.querySelector("img");
    if (!targetImage) return;

    // Link-URL vom Custom-Button holen
    const linkUrl = link.getAttribute("href");

    // 1. Bild klickbar machen - Container in Link umwandeln oder Link hinzufügen
    if (!targetImageContainer.classList.contains("has-link")) {
      // Container als Link markieren
      targetImageContainer.classList.add("has-link");

      // Cursor-Stil anpassen
      targetImageContainer.style.cursor = "pointer";

      // Click-Event hinzufügen
      targetImageContainer.addEventListener("click", (e) => {
        // Wenn kein Link-Element direkt geklickt wurde, zum Link navigieren
        if (!e.target.closest("a")) {
          window.location.href = linkUrl;
        }
      });
    }

    // 2. Hover-Events für den Zoom-Effekt
    link.removeEventListener("mouseenter", link._zoomEnterHandler);
    link.removeEventListener("mouseleave", link._zoomLeaveHandler);

    // Neue Handler als Eigenschaften speichern, um sie später entfernen zu können
    link._zoomEnterHandler = () => {
      targetImage.classList.add("scale-105");
    };

    link._zoomLeaveHandler = () => {
      targetImage.classList.remove("scale-105");
    };

    // Events hinzufügen
    link.addEventListener("mouseenter", link._zoomEnterHandler);
    link.addEventListener("mouseleave", link._zoomLeaveHandler);

    // 3. Hover-Events für das Bild selbst hinzufügen
    targetImageContainer.addEventListener("mouseenter", () => {
      targetImage.classList.add("scale-105");
      link.classList.add("hovered"); // Optional: Link-Styling anpassen
    });

    targetImageContainer.addEventListener("mouseleave", () => {
      targetImage.classList.remove("scale-105");
      link.classList.remove("hovered"); // Optional: Link-Styling zurücksetzen
    });
  });
}

// Externe Links in neuem Tab öffnen
document.addEventListener("DOMContentLoaded", function () {
  // Datei-Endungen die in neuem Tab geöffnet werden sollen
  const fileTypes = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".zip", ".rar"];

  // Alle Links durchgehen
  document.querySelectorAll("a").forEach(function (link) {
    const href = link.getAttribute("href");

    // Wenn kein href, überspringen
    if (!href) return;

    // Prüfen ob es ein PDF/Datei Link ist
    const isFile = fileTypes.some((type) => href.toLowerCase().endsWith(type));

    // Prüfen ob es ein externer Link ist
    const isExternal = href.startsWith("http") && !href.includes(window.location.hostname);

    // Wenn Datei oder externer Link, in neuem Tab öffnen
    if (isFile || isExternal) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      // Wenn es eine Datei ist, download Attribut setzen
      // if (isFile) {
      //   link.setAttribute("download", "");
      // }
    }
  });
});

// Instagram Lightbox Scroll-Handling für ScrollSmoother
document.addEventListener("DOMContentLoaded", function () {
  // Hilfsfunktion zum Deaktivieren des Scrollens
  function disableScroll() {
    // ScrollSmoother pausieren, wenn vorhanden
    if (window.ScrollSmoother && window.ScrollSmoother.get()) {
      window.ScrollSmoother.get().paused(true);
    }

    // Body-Overflow für Nicht-GSAP-Elemente deaktivieren
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    // Zusätzlich das smooth-wrapper und smooth-content blockieren
    const wrapper = document.getElementById("smooth-wrapper");
    const content = document.getElementById("smooth-content");

    if (wrapper) wrapper.style.pointerEvents = "none";
    if (content) content.style.pointerEvents = "none";
  }

  // Hilfsfunktion zum Aktivieren des Scrollens
  function enableScroll() {
    // ScrollSmoother wieder aktivieren
    if (window.ScrollSmoother && window.ScrollSmoother.get()) {
      window.ScrollSmoother.get().paused(false);
    }

    // Body-Overflow zurücksetzen
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";

    // Pointer-Events für Wrapper und Content wiederherstellen
    const wrapper = document.getElementById("smooth-wrapper");
    const content = document.getElementById("smooth-content");

    if (wrapper) wrapper.style.pointerEvents = "";
    if (content) content.style.pointerEvents = "";
  }

  // Status Variable, um den Zustand der Lightbox zu verfolgen
  let lightboxOpen = false;

  // Verbesserte Prüfung ob die Lightbox sichtbar ist
  function checkLightboxStatus() {
    const lightbox = document.getElementById("sbi_lightbox");

    if (!lightbox) return;

    const isVisible = window.getComputedStyle(lightbox).display !== "none";

    // Nur Status ändern wenn es einen Wechsel gab
    if (isVisible && !lightboxOpen) {
      lightboxOpen = true;
      disableScroll();
    } else if (!isVisible && lightboxOpen) {
      lightboxOpen = false;
      // Mit Verzögerung ausführen, um sicherzustellen, dass die Animation abgeschlossen ist
      setTimeout(enableScroll, 50);
    }
  }

  // MutationObserver mit verbesserter Konfiguration
  const observer = new MutationObserver(function () {
    checkLightboxStatus();
  });

  // Gesamten Body beobachten mit allen Attributen
  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ["style", "class"], // Nur diese Attribute beobachten
  });

  // Event-Listener für .sbi_link_area Links
  document.addEventListener("click", function (event) {
    // Prüfen ob ein .sbi_link_area geklickt wurde
    if (event.target.closest(".sbi_link_area")) {
      // Mit mehreren Timeouts prüfen, um das Öffnen zuverlässig zu erkennen
      [100, 300, 500].forEach((delay) => {
        setTimeout(checkLightboxStatus, delay);
      });
    }
  });

  // Event-Listener für das Schließen der Lightbox
  document.addEventListener("click", function (event) {
    // Auf den Schließen-Button oder den Overlay-Hintergrund prüfen
    if (
      event.target.closest(".sbi_lightbox_close_btn") ||
      event.target.classList.contains("sbi_lightbox_overlay")
    ) {
      // Direktes Freigeben zur sofortigen Reaktion
      lightboxOpen = false;
      enableScroll();

      // Zusätzlich mit Verzögerung prüfen
      setTimeout(checkLightboxStatus, 100);
    }
  });

  // ESC-Taste prüfen
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && lightboxOpen) {
      lightboxOpen = false;
      enableScroll();

      // Zusätzlich mit Verzögerung prüfen
      setTimeout(checkLightboxStatus, 100);
    }
  });

  // Zusätzlicher Interval-Check für mehr Zuverlässigkeit (alle 500ms)
  const intervalCheck = setInterval(function () {
    const lightbox = document.getElementById("sbi_lightbox");
    if (!lightbox) return;

    // Wenn die Lightbox existiert aber nicht mehr sichtbar ist und der Status noch auf offen steht
    if (window.getComputedStyle(lightbox).display === "none" && lightboxOpen) {
      lightboxOpen = false;
      enableScroll();
    }
  }, 500);

  // Interval löschen wenn die Seite verlassen wird
  window.addEventListener("beforeunload", function () {
    clearInterval(intervalCheck);
  });
});

// COOKIE ALERT
document.addEventListener("DOMContentLoaded", function () {
  "use strict";
  var cookieAlert = document.querySelector(".cookiealert");
  var acceptCookies = document.querySelector(".acceptcookies");

  // Prüfen, ob die Cookie-Alert-Elemente existieren
  if (!cookieAlert || !acceptCookies) {
    console.warn("Cookie-Alert-Elemente nicht gefunden");
    return;
  }

  // Nur anzeigen, wenn Cookie nicht gesetzt
  if (!getCookie("acceptCookies")) {
    cookieAlert.classList.add("show");
  }

  acceptCookies.addEventListener("click", function () {
    setCookie("acceptCookies", true, 60);
    cookieAlert.classList.remove("show");
  });
});

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

//AKKORDEON
document.addEventListener("DOMContentLoaded", () => {
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const accordionCell = header.closest(".accordion-cell");
      const content = accordionCell.querySelector(".accordion-content");
      const arrow = header.querySelector(".accordion-arrow");

      // Toggle
      if (content.style.maxHeight && content.style.maxHeight !== "0px") {
        // Schließen
        content.style.maxHeight = "0px";
        arrow.style.transform = "rotate(180deg)";
        accordionCell.classList.remove("active");
      } else {
        // Öffnen
        content.style.maxHeight = content.scrollHeight + "px";
        arrow.style.transform = "rotate(0deg)";
        accordionCell.classList.add("active");
      }
    });
  });
});

//MAP
document.addEventListener("DOMContentLoaded", () => {
  let map;
  let markerLogo;
  let markerParking;

  //Style vom Snazzy Map Hof zu WIl auf der Website
  const snazzyMapStyle = [
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          visibility: "off",
        },
        {
          color: "#444444",
        },
      ],
    },
    {
      featureType: "administrative.neighborhood",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#f5f5f5",
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#a8a9a8",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        {
          saturation: "-100",
        },
        {
          lightness: "45",
        },
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "geometry.fill",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#000000",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "all",
      stylers: [
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "all",
      stylers: [
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#ffffff",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
  ];

  // Funktion um die aktuelle Farbe aus dem klein-hero zu bekommen
  // function getCurrentHeroColor() {
  //   // Fallback: Suche nach dem hero Element
  //   const hero = document.querySelector(".hero");

  //   // Suche nach sichtbaren random-bg Elementen im hero
  //   const visibleRandomBg = hero.querySelector(".random-bg[style*='display: grid']");

  //   // Suche nach einem Element mit --clip-path-color CSS-Variable
  //   const clipPathElement = visibleRandomBg.querySelector("[style*='--clip-path-color']");
  //   if (clipPathElement) {
  //     const color = clipPathElement.style.getPropertyValue("--clip-path-color").trim();
  //     if (color) return color;
  //   }
  // }

  function getCurrentHeroColor() {
    try {
      // Suche nach dem hero Element
      const hero = document.querySelector(".hero");
      if (!hero) {
        // Fallback-Farbe: Eine der Zufallsfarben wählen
        const randomColors = [
          "rgb(255,220,0)", // randomgelb
          "rgb(255,92,87)", // randomrot
          "rgb(80,70,196)", // randomblau
          "rgb(0,215,147)", // randomgruen
        ];
        return randomColors[Math.floor(Math.random() * randomColors.length)];
      }

      // Suche nach sichtbaren random-bg Elementen im hero
      const visibleRandomBg = hero.querySelector(".random-bg[style*='display: grid']");
      if (!visibleRandomBg) {
        // Fallback-Farbe: Eine der Zufallsfarben wählen
        const randomColors = [
          "rgb(255,220,0)", // randomgelb
          "rgb(255,92,87)", // randomrot
          "rgb(80,70,196)", // randomblau
          "rgb(0,215,147)", // randomgruen
        ];
        return randomColors[Math.floor(Math.random() * randomColors.length)];
      }

      // Suche nach einem Element mit --clip-path-color CSS-Variable
      const clipPathElement = visibleRandomBg.querySelector("[style*='--clip-path-color']");
      if (clipPathElement) {
        const color = clipPathElement.style.getPropertyValue("--clip-path-color").trim();
        if (color) return color;
      }

      // Fallback-Farbe: Eine der Zufallsfarben wählen
      const randomColors = [
        "rgb(255,220,0)", // randomgelb
        "rgb(255,92,87)", // randomrot
        "rgb(80,70,196)", // randomblau
        "rgb(0,215,147)", // randomgruen
      ];
      return randomColors[Math.floor(Math.random() * randomColors.length)];
    } catch (e) {
      console.warn("Error getting hero color:", e);
      // Fallback-Farbe: Eine der Zufallsfarben wählen
      const randomColors = [
        "rgb(255,220,0)", // randomgelb
        "rgb(255,92,87)", // randomrot
        "rgb(80,70,196)", // randomblau
        "rgb(0,215,147)", // randomgruen
      ];
      return randomColors[Math.floor(Math.random() * randomColors.length)];
    }
  }

  // SVG Marker als Funktion mit dynamischer Farbe
  function createSvgMarkerLogo(color) {
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg width="52" height="62" viewBox="0 0 52 62" fill="none" xmlns="http://www.w3.org/2000/svg">
          <!-- Main icon -->
          <rect width="52" height="52" rx="4" fill="${color}" />
          <path d="M34.5856 32.6469L34.8449 39.0394L34.5856 45.8039H42.5861L42.8846 43.3135L37.3122 43.7844L37.6309 32.6469H34.5856Z" fill="black" />
          <path d="M27.6817 17.4313C26.8459 17.4313 26.1127 17.2448 25.4826 16.8724C24.8524 16.4996 24.3647 15.9737 24.0197 15.294C23.6748 14.6142 23.5025 13.8232 23.5025 12.9215C23.5025 12.0197 23.6748 11.2322 24.0197 10.5586C24.3647 9.88546 24.8524 9.3596 25.4826 8.98016C26.1127 8.60115 26.8459 8.41165 27.6817 8.41165C28.5439 8.41165 29.29 8.60115 29.9206 8.98016C30.5503 9.3596 31.0349 9.88898 31.3732 10.5687C31.7114 11.2485 31.8806 12.0329 31.8806 12.9215C31.8806 13.8232 31.7114 14.6142 31.3732 15.294C31.0349 15.9737 30.5503 16.4996 29.9206 16.8724C29.29 17.2448 28.5439 17.4313 27.6817 17.4313ZM38.7859 8.47057L44 8.64688L43.5618 6.33328H35.7808L36.0196 12.7056L35.7808 19.4899L35.7813 19.4903H33.7111L33.8106 27.1372C33.8369 28.3266 33.5884 29.2191 33.0645 29.8136C32.5401 30.4085 31.8337 30.7057 30.9448 30.7057C30.0558 30.7057 29.3561 30.4151 28.8451 29.8334C28.3346 29.2517 28.0856 28.353 28.099 27.1372L28.2328 19.8056C29.0473 19.7576 29.8157 19.6046 30.5373 19.343C31.4196 19.0229 32.1822 18.5586 32.8257 17.9505C33.4692 17.3429 33.9668 16.6174 34.3185 15.7746C34.6697 14.9312 34.8459 13.9802 34.8459 12.9215C34.8459 11.8627 34.6697 10.9086 34.3185 10.0587C33.9668 9.20923 33.4692 8.48376 32.8257 7.88228C32.1822 7.28123 31.4196 6.81693 30.5373 6.49024C29.6551 6.16356 28.7032 6 27.6817 6C26.6468 6 25.6945 6.16356 24.8257 6.49024C23.9568 6.81693 23.204 7.28123 22.5672 7.88228C21.9304 8.48376 21.4359 9.20923 21.0843 10.0587C20.7326 10.9086 20.5572 11.8627 20.5572 12.9215C20.5572 13.9802 20.7326 14.9312 21.0843 15.7746C21.4359 16.6174 21.9304 17.3429 22.5672 17.9505C23.204 18.5586 23.9568 19.0229 24.8257 19.343C24.9399 19.3848 25.0559 19.4226 25.1729 19.4586L25.3527 27.3923C25.379 28.5425 25.5848 29.5361 25.9694 30.3724C26.3541 31.2091 26.9548 31.8528 27.7705 32.3039C28.0164 32.4394 28.2864 32.5523 28.576 32.6469H25.99L23.4824 43.0783H23.4226L20.696 32.6469H23.8805L24.1987 30.1372L17.3134 30.7255L24.0197 21.4508V19.4903H19.5817L19.5822 19.4899L19.3434 12.7254L19.5822 6.33328H16.5173L16.756 11.3918L13.7911 11.4705L10.8257 11.3918L11.0644 6.33328H8L8.25838 12.7254L8 19.4899H11.0644L10.8257 13.8039L13.7911 13.7252L16.756 13.8039L16.5173 19.4899L16.5177 19.4903H14.6265L14.3279 21.9802L20.7759 21.4706L14.1289 30.6468V32.6469H17.5521L14.925 43.0392H14.8451L12.139 32.6469H8.91483L13.094 46L16.4177 45.8822L19.1042 35.6666H19.1439L21.751 46L25.0742 45.8628L28.9803 32.7625C29.1227 32.7981 29.2691 32.8289 29.4208 32.8553L29.6711 39.0394L29.4123 45.8039H32.4772L32.2184 39.0394L32.4701 32.821C32.998 32.7036 33.4822 32.5229 33.9199 32.2745C34.7491 31.804 35.3926 31.1471 35.8505 30.3038C36.3083 29.4605 36.5435 28.4835 36.5569 27.3725L36.7162 19.4903L38.8257 19.4899L38.6467 14.098L43.0048 14.1565L43.2637 11.8627L38.6266 11.9212L38.7859 8.47057Z" fill="black" />
          <!-- Arrow positioned below the main icon -->
          <path d="M26 62L20.2308 52L31.7692 52L26 62Z" fill="${color}" />
      </svg>
  `)}`;
  }

  function createSvgMarkerParking() {
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" rx="12" fill="#000"/>
<path d="M9.218 17L9.386 12.17L9.232 7.606H12.48C13.1707 7.606 13.768 7.73667 14.272 7.998C14.7853 8.25 15.1773 8.60933 15.448 9.076C15.728 9.53333 15.868 10.0653 15.868 10.672C15.868 11.3253 15.7327 11.8947 15.462 12.38C15.1913 12.856 14.7993 13.2247 14.286 13.486C13.782 13.7473 13.18 13.878 12.48 13.878H10.842L10.954 17H9.218ZM10.8 12.646H12.424C13.0027 12.6553 13.4553 12.4827 13.782 12.128C14.1087 11.7733 14.272 11.302 14.272 10.714C14.272 10.098 14.1087 9.63133 13.782 9.314C13.4553 8.98733 12.9793 8.82867 12.354 8.838H10.898L10.8 12.646Z" fill="white"/>
</svg>
`)}`;
  }

  // Funktion um zu überprüfen ob Google Maps API geladen ist
  function checkGoogleMapsLoaded() {
    return new Promise((resolve) => {
      if (typeof google !== "undefined" && google.maps) {
        resolve();
      } else {
        const checkInterval = setInterval(() => {
          if (typeof google !== "undefined" && google.maps) {
            clearInterval(checkInterval);
            resolve();
          }
        }, 100);
      }
    });
  }

  // Funktion um die Marker-Farben zu aktualisieren
  function updateMarkerColors() {
    if (!markerLogo || !markerParking) return;

    const currentColor = getCurrentHeroColor();

    // Logo Marker aktualisieren
    markerLogo.setIcon({
      url: createSvgMarkerLogo(currentColor),
      scaledSize: new google.maps.Size(52, 62),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(26, 62), // Pfeilspitze als Ankerpunkt
    });

    // Parking Marker aktualisieren
    markerParking.setIcon({
      url: createSvgMarkerParking(),
      scaledSize: new google.maps.Size(26, 26),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 0),
    });
  }

  //Koordinaten HofzuWIl
  window.initMap = async function () {
    // Warten bis Google Maps geladen ist
    await checkGoogleMapsLoaded();

    const hofzuwil = {
      lat: 47.467659,
      lng: 9.050196,
    };

    const parking = {
      lat: 47.466,
      lng: 9.049722,
    };

    // Map initialisieren
    const mapElement = document.getElementById("map");
    if (!mapElement) {
      console.warn("Map element nicht gefunden");
      return;
    }

    map = new google.maps.Map(mapElement, {
      zoom: 15,
      center: hofzuwil,
      styles: snazzyMapStyle,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      zoomControl: true,
    });

    // Aktuelle Farbe ermitteln
    const currentColor = getCurrentHeroColor();

    // Custom Marker erstellen mit aktueller Farbe
    markerLogo = new google.maps.Marker({
      position: hofzuwil,
      map: map,
      icon: {
        url: createSvgMarkerLogo(currentColor),
        scaledSize: new google.maps.Size(52, 62),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(26, 62), // Pfeilspitze als Ankerpunkt
      },
      title: "HOF ZU WIL",
    });

    markerParking = new google.maps.Marker({
      position: parking,
      map: map,
      icon: {
        url: createSvgMarkerParking(),
        scaledSize: new google.maps.Size(26, 26),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 0),
      },
      title: "P",
    });

    // Optional: Animation beim Laden
    markerLogo.setAnimation(google.maps.Animation.DROP);
    markerParking.setAnimation(google.maps.Animation.DROP);
  };

  // Map initialisieren wenn Element existiert
  initMap()
    .then(() => {
      // Initiale Farbe nach kurzer Verzögerung setzen
      updateMarkerColors();
    })
    .catch((e) => {
      console.warn("Map initialization error:", e);
    });
});

//GAST WLAN Overlay anzeigen als Erstes
document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("gast-wlan-bestaetigung");
  const checkbox = document.getElementById("nutzungsbedingungen-checked");
  const button = document.getElementById("wlan-bestaetigen");
  const homeButton = document.querySelector(".startseitemenu");
  const hamburger = document.querySelector(".hamburger");
  const bedingungenLink = document.querySelector(".underline-white");
  const acceptBtn = document.querySelector(".custom-btn-black");

  if (overlay) {
    // Overlay sofort anzeigen OHNE Animation
    overlay.classList.remove("-translate-x-[200%]");
    overlay.classList.add("translate-x-0");
    homeButton.style.display = "none";
    hamburger.style.display = "none";
  } else {
    return;
  }

  bedingungenLink.addEventListener("click", () => {
    // ERST jetzt Animation hinzufügen
    overlay.classList.add("transition-all", "duration-500", "ease-in-out", "transform");

    // Dann animiert schließen
    overlay.classList.remove("translate-x-0");
    overlay.classList.add("-translate-x-[200%]");

    homeButton.style.display = "flex";
    hamburger.style.display = "block";
  });

  acceptBtn.addEventListener("click", (e) => {
    e.preventDefault();
    overlay.classList.add("translate-x-0");
    overlay.classList.remove("-translate-x-[200%]");

    setTimeout(() => {
      homeButton.style.display = "none";
      hamburger.style.display = "none";
    }, 200);
    checkbox.checked = true;
  });
});

// Zahlungsmittel Logic
document.addEventListener("DOMContentLoaded", () => {
  function initPaymentSelection() {
    const paymentMethods = document.querySelectorAll(".zahlungsmittel");
    const paymentDetails = document.querySelectorAll(".payment-details");

    if (!paymentMethods.length) return;

    // Event-Listener für alle Zahlungsmittel
    paymentMethods.forEach((method, index) => {
      method.addEventListener("click", (e) => {
        e.preventDefault();

        // Entsprechende Details-Box finden (gleiches Container-Element)
        const container = method.closest(".zahlungsmittel-container");
        const targetDetails = container ? container.querySelector(".payment-details") : null;

        if (!targetDetails) return;

        // Toggle-Funktionalität
        const isCurrentlyActive = method.classList.contains("active");

        if (isCurrentlyActive) {
          // Wenn bereits aktiv, verstecke Details und zeige Zahlungsmittel wieder an
          targetDetails.classList.add("hidden");
          targetDetails.classList.remove("flex");
          targetDetails.classList.remove("show");
          method.classList.remove("active");

          // Zahlungsmittel wieder einblenden
          if (window.innerWidth < 768) {
            method.style.display = "block";
          }
        } else {
          // Alle anderen Details verstecken und Methods deaktivieren
          paymentDetails.forEach((detail) => {
            detail.classList.add("hidden");
            detail.classList.remove("show");
          });
          paymentMethods.forEach((m) => {
            m.classList.remove("active");

            // Zahlungsmittel wieder einblenden
            if (window.innerWidth < 768) {
              m.style.display = "block";
            }
          });

          // Gewählte Details anzeigen
          targetDetails.classList.remove("hidden");
          targetDetails.classList.add("flex");
          method.classList.add("active");

          // Zahlungsmittel ausblenden
          if (window.innerWidth < 768) {
            method.style.display = "none";
          }

          // Smooth fade-in animation
          setTimeout(() => {
            targetDetails.classList.add("show");
          }, 10);
        }
      });
    });
  }

  // Initialisiere Payment Selection
  initPaymentSelection();
});

// In main.js - Social Media Hover Effekt
document.addEventListener("DOMContentLoaded", () => {
  function initSocialMediaHover() {
    const socialIcons = document.querySelectorAll(".social_media_icon[data-hover]");

    socialIcons.forEach((icon) => {
      const originalSrc = icon.dataset.original;
      const hoverSrc = icon.dataset.hover;

      // Hover-Bild vorladen für smooth transition
      const hoverImg = new Image();
      hoverImg.src = hoverSrc;

      icon.addEventListener("mouseenter", () => {
        icon.src = hoverSrc;
      });

      icon.addEventListener("mouseleave", () => {
        icon.src = originalSrc;
      });
    });
  }

  initSocialMediaHover();
});

//
document.addEventListener("DOMContentLoaded", () => {
  function initSocialMediaHover() {
    const socialIcons = document.querySelectorAll(".social_media_icon[data-hover]");
    socialIcons.forEach((icon) => {
      const originalSrc = icon.dataset.original;
      const hoverSrc = icon.dataset.hover;
      // Hover-Bild vorladen für smooth transition
      const hoverImg = new Image();
      hoverImg.src = hoverSrc;
      icon.addEventListener("mouseenter", () => {
        icon.src = hoverSrc;
      });
      icon.addEventListener("mouseleave", () => {
        icon.src = originalSrc;
      });
    });
  }
});
// Neue Funktion für Flickity Bildunterschriften
document.addEventListener("DOMContentLoaded", function () {
  // Für alle Flickity Carousels
  const carousels = document.querySelectorAll(".bilderCarousel");

  carousels.forEach(function (carousel) {
    const captionsData = carousel.getAttribute("data-captions");
    const captionElement = carousel.parentElement.querySelector(".carousel-caption");

    if (captionsData && captionElement) {
      const captions = JSON.parse(captionsData);

      // Flickity initialisieren (falls noch nicht geschehen)
      const flkty = new Flickity(carousel, {
        // Deine Flickity Optionen hier
        cellAlign: "left",
        contain: true,
        pageDots: true,
        prevNextButtons: true,
      });

      // Funktion zum Aktualisieren der Bildunterschrift
      function updateCaption(index) {
        const caption = captions[index];
        if (caption && caption.trim() !== "") {
          captionElement.textContent = caption;
          captionElement.style.display = "block";
        } else {
          captionElement.style.display = "none";
        }
      }

      // Beim Start die erste Bildunterschrift anzeigen
      updateCaption(0);

      // Event Listener für Slide-Wechsel
      flkty.on("change", function (index) {
        updateCaption(index);
      });
    }
  });
});

// Line Height Change when two liner Block BILD TEXT STICKY TITEL

// function checkMultiline(title) {
//   const computedStyle = window.getComputedStyle(title);
//   const lineHeight = parseInt(computedStyle.lineHeight);
//   const paddingTop = parseInt(computedStyle.paddingTop);
//   const paddingBottom = parseInt(computedStyle.paddingBottom);
//   const contentHeight = title.scrollHeight - paddingTop - paddingBottom;
//   const lineCount = Math.round(contentHeight / lineHeight);

//   if (lineCount > 1) {
//     title.classList.add("multiline");
//   } else {
//     title.classList.remove("multiline");
//   }
// }

// document.addEventListener("DOMContentLoaded", function () {
//   const titles = document.querySelectorAll(".sticky-titel");

//   // Einmaliger Check beim Laden
//   titles.forEach(checkMultiline);

//   // ResizeObserver für dynamische Änderungen
//   const resizeObserver = new ResizeObserver((entries) => {
//     entries.forEach((entry) => {
//       checkMultiline(entry.target);
//     });
//   });

//   // Alle Titel beobachten
//   titles.forEach((title) => {
//     resizeObserver.observe(title);
//   });
// });

// --- Anchor navigation for StopScroller and ScrollSmoother ---
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Helper: close mobile/offcanvas nav if open (prefer header API)
    function closeMenuIfOpen() {
      try {
        // Bevorzugt die globale Header-API, wenn verfügbar
        if (window.HZW_menu && typeof window.HZW_menu.isOpen === "function") {
          if (window.HZW_menu.isOpen()) {
            if (typeof window.HZW_menu.close === "function") {
              window.HZW_menu.close();
              return true;
            }
          }
          return false;
        }

        // Fallback: Klassenbasiertes Schließen
        let closed = false;
        const body = document.body;
        if (body.classList.contains("menu-open") || body.classList.contains("nav-open")) {
          body.classList.remove("menu-open", "nav-open");
          closed = true;
        }
        document
          .querySelectorAll(
            ".menu.active, .navbar.active, .nav.active, .mobile-nav.open, .offcanvas.show",
          )
          .forEach((el) => {
            el.classList.remove("active", "open", "show");
            closed = true;
          });
        document
          .querySelectorAll(
            ".menu-toggle, .navbar-toggler, .hamburger, .hambi, [aria-expanded='true']",
          )
          .forEach((btn) => {
            if (btn.getAttribute("aria-expanded") === "true")
              btn.setAttribute("aria-expanded", "false");
            btn.classList.remove("active", "is-active");
          });
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
        try {
          window.ScrollSmoother &&
            window.ScrollSmoother.get() &&
            window.ScrollSmoother.get().paused(false);
        } catch {}
        return closed;
      } catch {
        return false;
      }
    }
    // Polyfill: CSS.escape (für ältere Browser/Server-Umgebungen)
    if (typeof window.CSS === "undefined") {
      window.CSS = {};
    }
    if (typeof window.CSS.escape !== "function") {
      window.CSS.escape = function (value) {
        return String(value)
          .replace(/\0/g, "\uFFFD")
          .replace(/(^[0-9])|[^a-zA-Z0-9_\-\u00A0-\uFFFF]/g, function (ch, asFirst) {
            return asFirst ? "\\3" + ch + " " : "\\" + ch;
          });
      };
    }
    // Helper: get ScrollSmoother instance (if any)
    const getSmoother = () =>
      window.ScrollSmoother && window.ScrollSmoother.get ? window.ScrollSmoother.get() : null;

    // Compute header offset if there's a fixed header; adjust as needed
    function getHeaderOffset() {
      // Try common selectors; can be adapted
      const header = document.querySelector("header.sticky, header.fixed, .site-header");
      if (header) {
        const styles = window.getComputedStyle(header);
        const isFixed = styles.position === "fixed" || styles.position === "sticky";
        if (isFixed) return header.offsetHeight || 0;
      }
      return 0;
    }

    // Resolve a target element from a hash that can be either an exact id (#stopscroll-2)
    // or a slug matching data-anchor on a StopScroller panel
    function resolveTargetFromHash(rawHash) {
      if (!rawHash) return null;
      const hash = rawHash.replace(/^#/, "").trim();
      if (!hash) return null;

      const isMobile = window.innerWidth < 1024; // lg breakpoint

      // 1) Mobile zuerst: direct id mit -m suffix
      if (isMobile) {
        let el = document.getElementById(`${hash}-m`);
        if (el) return el;
      }

      // 1) direct id
      let el = document.getElementById(hash);
      if (el) return el;

      // 2) Mobile zuerst: data-anchor lookup inside mobile container
      if (isMobile) {
        el = document.querySelector(`.lg\\:hidden [data-anchor='${CSS.escape(hash)}']`);
        if (el) return el;
      }

      // 2) try stopscroller slug via data-anchor
      el = document.querySelector(
        `.scroll-container .image-scroll > div[data-anchor="${CSS.escape(hash)}"]`,
      );
      if (el) return el;

      // 3) Mobile zuerst: numeric like #2 -> map to stopscroll-2-m
      if (/^\d+$/.test(hash)) {
        if (isMobile) {
          el = document.getElementById(`stopscroll-${hash}-m`);
          if (el) return el;
        }

        el = document.getElementById(`stopscroll-${hash}`);
        if (el) return el;
      }

      // 4) Mobile zuerst: prefixed forms like stopscroll-2 -> stopscroll-2-m
      if (hash.startsWith("stopscroll-")) {
        if (isMobile) {
          el = document.getElementById(`${hash}-m`);
          if (el) return el;
        }

        el = document.getElementById(hash);
        if (el) return el;
      }

      return null;
    }

    function scrollToElement(el) {
      if (!el) return;

      const isMobile = window.innerWidth < 1024; // lg breakpoint
      const smoother = getSmoother();
      const offset = -getHeaderOffset(); // negative offset moves target a bit lower to account header height

      const postScrollFix = (delay = 80) => {
        setTimeout(() => {
          try {
            fixLogoSpacerAfterScroll();
            ScrollTrigger && ScrollTrigger.refresh && ScrollTrigger.refresh(true);
          } catch {}
        }, delay);
      };

      // Mobile: einfacher Scroll ohne komplexe StopScroller-Logik und ohne Smoother,
      // da Smoother auf Mobile/bei versteckten StopScroller-Containern einfrieren kann
      if (isMobile) {
        const top = el.getBoundingClientRect().top + window.pageYOffset + offset;
        requestAnimationFrame(() => {
          window.scrollTo({ top, behavior: "smooth" });
          postScrollFix(120);
        });
        return;
      }

      // Desktop: Special handling für StopScroller panels mit data-stop-index
      const panelIndexAttr = el.getAttribute("data-stop-index");
      const panelIndex = panelIndexAttr != null ? parseInt(panelIndexAttr, 10) : NaN;
      const stopContainer = el.closest(".scroll-container");

      if (!isNaN(panelIndex) && stopContainer && window.ScrollTrigger) {
        // Find the ScrollTrigger for the stopscroller container
        // Ensure triggers are fresh
        try {
          ScrollTrigger.refresh(true);
        } catch {}
        const st = ScrollTrigger.getAll().find((t) => t.vars && t.vars.trigger === stopContainer);
        if (st && typeof st.start === "number" && typeof st.end === "number") {
          // Determine how many panels exist by checking siblings with data-stop-index
          const panels = Array.from(
            stopContainer.querySelectorAll(".image-scroll > div[data-stop-index]"),
          );
          const maxIndex = Math.max(
            0,
            ...panels
              .map((p) => parseInt(p.getAttribute("data-stop-index"), 10))
              .filter((n) => !isNaN(n)),
          );

          // Exact mapping to match onUpdate rounding:
          // imageIndex = round((progress * maxIndex) / 0.7) for progress < 0.7
          // To land exactly on a given panelIndex (except the last), choose
          //   progress = 0.7 * panelIndex / maxIndex
          // For the last panel, use a value within [0.7, 1)
          let targetProgress;
          if (panelIndex >= maxIndex) {
            targetProgress = 0.85; // safely in the last segment
          } else {
            targetProgress = maxIndex > 0 ? (0.7 * panelIndex) / maxIndex : 0;
          }

          const absoluteY = st.start + targetProgress * (st.end - st.start);
          if (smoother) {
            // No header offset inside pinned region
            smoother.scrollTo(absoluteY, true);
            // Nach dem Scroll kurz Logo/Trigger korrigieren
            postScrollFix(80);
          } else if (typeof window.scrollTo === "function") {
            window.scrollTo({ top: absoluteY, behavior: "smooth" });
            postScrollFix(120);
          }
          return; // handled
        }
      }

      // Default: scroll directly to element
      if (smoother) {
        smoother.scrollTo(el, true, { offset });
        postScrollFix(120);
      } else if (typeof window.scrollTo === "function") {
        const top = el.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({ top, behavior: "smooth" });
        postScrollFix(120);
      }
    }

    // Intercept clicks on same-page links that contain a hash (bubble phase)
    document.addEventListener(
      "click",
      function (e) {
        const a = e.target.closest("a");
        if (!a) return;
        const hrefAttr = a.getAttribute("href");
        if (!hrefAttr || !hrefAttr.includes("#")) return;

        let url;
        try {
          url = new URL(a.href, window.location.href);
        } catch (err) {
          return;
        }

        // Only intercept same-page hashes (tolerant path comparison)
        if (!url.hash) return;
        const normalizePath = (p) => {
          if (!p) return "/";
          let np = p.replace(/index\.php$/i, "");
          np = np.replace(/\/+/, "/");
          if (np.length > 1 && np.endsWith("/")) np = np.slice(0, -1);
          return np || "/";
        };
        const sameOrigin = url.origin === window.location.origin;
        const urlPath = normalizePath(url.pathname);
        const curPath = normalizePath(window.location.pathname);
        const isHome = !!(
          document.body &&
          document.body.classList &&
          document.body.classList.contains("home")
        );
        const samePage = sameOrigin && (urlPath === curPath || (isHome && urlPath === "/"));
        if (!samePage) return;

        const target = resolveTargetFromHash(url.hash);
        if (!target) return;

        // Stop default hash navigation, but let other click handlers (like nav close) run
        e.preventDefault();

        // Immediately write the hash into the URL (no extra history entry)
        try {
          if (window.history && typeof window.history.replaceState === "function") {
            window.history.replaceState(null, "", url.hash);
          } else {
            window.location.hash = url.hash; // older fallback
          }
        } catch {}

        // Close menu if open, then scroll (give CSS transitions time)
        const wasClosed = closeMenuIfOpen();

        const doScroll = () => {
          scrollToElement(target);
          // Safety refresh shortly after for slower environments
          setTimeout(() => {
            try {
              ScrollTrigger && ScrollTrigger.refresh && ScrollTrigger.refresh(true);
            } catch {}
          }, 120);
        };

        if (wasClosed) {
          setTimeout(() => requestAnimationFrame(doScroll), 250);
        } else {
          requestAnimationFrame(doScroll);
        }
      },
      false,
    );

    // On load with existing hash - scrolle direkt zum Ankerpunkt mit ScrollSmoother
    if (window.location.hash) {
      const scrollToHashTarget = (instant = false) => {
        const target = resolveTargetFromHash(window.location.hash);
        if (!target) return false;

        const smoother = getSmoother();
        const offset = -getHeaderOffset();

        // Prüfe ob es ein StopScroller-Panel ist
        const panelIndexAttr = target.getAttribute("data-stop-index");
        const panelIndex = panelIndexAttr != null ? parseInt(panelIndexAttr, 10) : NaN;
        const stopContainer = target.closest(".scroll-container");

        // StopScroller-Panel: Verwende die spezielle Logik
        if (!isNaN(panelIndex) && stopContainer && window.ScrollTrigger) {
          try {
            ScrollTrigger.refresh(true);
          } catch {}
          const st = ScrollTrigger.getAll().find((t) => t.vars && t.vars.trigger === stopContainer);
          if (st && typeof st.start === "number" && typeof st.end === "number") {
            const panels = Array.from(
              stopContainer.querySelectorAll(".image-scroll > div[data-stop-index]"),
            );
            const maxIndex = Math.max(
              0,
              ...panels
                .map((p) => parseInt(p.getAttribute("data-stop-index"), 10))
                .filter((n) => !isNaN(n)),
            );

            let targetProgress;
            if (panelIndex >= maxIndex) {
              targetProgress = 0.85;
            } else {
              targetProgress = maxIndex > 0 ? (0.7 * panelIndex) / maxIndex : 0;
            }

            const absoluteY = st.start + targetProgress * (st.end - st.start);
            if (smoother) {
              smoother.scrollTo(absoluteY, !instant); // instant=true -> smooth=false
            } else {
              window.scrollTo({ top: absoluteY, behavior: instant ? "instant" : "smooth" });
            }
            return true;
          }
        }

        // Normales Element: Berechne die Zielposition
        const targetRect = target.getBoundingClientRect();
        const targetTop = targetRect.top + window.pageYOffset + offset;

        if (smoother) {
          smoother.scrollTo(targetTop, !instant); // instant=true -> smooth=false
        } else {
          window.scrollTo({ top: targetTop, behavior: instant ? "instant" : "smooth" });
        }

        return true;
      };

      // Sofort versuchen nach DOMContentLoaded (wir sind bereits drin)
      const tryImmediately = () => {
        const target = resolveTargetFromHash(window.location.hash);
        if (target) {
          // Beim ersten Laden: instant scroll
          scrollToHashTarget(true);
        }
      };

      // Erster Versuch sofort
      tryImmediately();

      // Zweiter Versuch nach window.load (alle Bilder/Ressourcen geladen)
      window.addEventListener(
        "load",
        () => {
          // Kurze Verzögerung damit ScrollSmoother und ScrollTrigger fertig initialisiert sind
          setTimeout(() => {
            try {
              ScrollTrigger && ScrollTrigger.refresh && ScrollTrigger.refresh(true);
            } catch {}
            // Nach dem Laden nochmal korrigieren (instant)
            scrollToHashTarget(true);
          }, 50);
        },
        { once: true },
      );
    }

    // Auf Hash-Änderungen reagieren (Back/Forward und manuelle Eingaben)
    window.addEventListener("hashchange", function () {
      const target = resolveTargetFromHash(window.location.hash);
      if (target) scrollToElement(target);
    });

    // Reagiere auf das globale Menü-Schließen-Event: Logo/Trigger stabilisieren
    window.addEventListener("hzw:menuClosed", () => {
      try {
        fixLogoSpacerAfterScroll();
        ScrollTrigger && ScrollTrigger.refresh && ScrollTrigger.refresh(true);
      } catch {}
    });
  });
})();
// Flickity Slider Initialisierung News Slider
document.addEventListener("DOMContentLoaded", function () {
  var carousel = document.querySelector(".newsCarousel");
  if (carousel && window.Flickity) {
    var flkty = new Flickity(carousel, {
      cellAlign: "left",
      contain: true,
      pageDots: true,
      groupCells: false,
      wrapAround: false,
      prevNextButtons: false,
      imagesLoaded: true,
      draggable: true,
      freeScroll: false,
      setGallerySize: true,
    });

    // Funktion: Alle Zellen gleich hoch machen (Höhe der höchsten Zelle)
    function setEqualCellHeight() {
      var cells = carousel.querySelectorAll(".carousel-cell");
      if (cells.length === 0) return;

      // Zuerst alle Höhen zurücksetzen
      cells.forEach(function (cell) {
        cell.style.height = "auto";
      });

      // Höchste Zelle finden
      var maxHeight = 0;
      cells.forEach(function (cell) {
        var cellHeight = cell.offsetHeight;
        if (cellHeight > maxHeight) {
          maxHeight = cellHeight;
        }
      });

      // Alle Zellen auf die maximale Höhe setzen
      cells.forEach(function (cell) {
        cell.style.height = maxHeight + "px";
      });

      // Flickity neu berechnen lassen
      flkty.resize();
    }

    // Höhe setzen nach verschiedenen Events
    flkty.on("ready", setEqualCellHeight);
    flkty.on("imagesLoaded", setEqualCellHeight);
    flkty.on("change", setEqualCellHeight);

    // Bei Window Resize
    window.addEventListener("resize", function () {
      setEqualCellHeight();
    });

    // Sicherheits-Timeout für spätes Bild-Laden
    setTimeout(setEqualCellHeight, 100);
    setTimeout(setEqualCellHeight, 500);
  }
});

// Custom Cursor Implementation - Desktop Only
document.addEventListener("DOMContentLoaded", function () {
  // Nur auf Desktop (>= 1024px) aktivieren
  const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
  if (!isDesktop) return;

  const customCursorElements = document.querySelectorAll(".custom-cursor");

  if (customCursorElements.length === 0) return;

  // Create cursor element
  const cursorIcon = document.createElement("div");
  cursorIcon.className = "custom-cursor-icon";
  cursorIcon.innerHTML = `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="24" fill="black"/>
      <g clip-path="url(#clip0_736_2445)">
        <path d="M31 26.7604L24.0105 32.5L17 26.7604L18.4605 25.0469L22.9262 29.362L22.6762 16.5L25.3262 16.5L25.0738 29.362L29.5184 25.0469L31 26.7604Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_736_2445">
          <rect width="16" height="16" fill="white" transform="matrix(-4.37114e-08 1 1 4.37114e-08 16 16.5)"/>
        </clipPath>
      </defs>
    </svg>
  `;
  cursorIcon.style.cssText = `
    position: fixed;
    pointer-events: none;
    z-index: 9999;
    width: 48px;
    height: 48px;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.2s ease;
  `;
  document.body.appendChild(cursorIcon);

  // Track mouse movement
  let cursorVisible = false;

  document.addEventListener("mousemove", function (e) {
    cursorIcon.style.left = e.clientX + "px";
    cursorIcon.style.top = e.clientY + "px";
  });

  // Show/hide cursor on hover
  customCursorElements.forEach((element) => {
    element.addEventListener("mouseenter", function () {
      cursorIcon.style.display = "block";
      cursorIcon.style.opacity = "1";
      cursorVisible = true;
      element.style.cursor = "none";
    });

    element.addEventListener("mouseleave", function () {
      cursorIcon.style.opacity = "0";
      setTimeout(() => {
        if (!cursorVisible) cursorIcon.style.display = "none";
      }, 200);
      cursorVisible = false;
      element.style.cursor = "";
    });

    // Verstecke Cursor über .no-down-cursor Elementen
    const noDownCursorElements = element.querySelectorAll(".no-down-cursor");
    noDownCursorElements.forEach((noDownEl) => {
      noDownEl.addEventListener("mouseenter", function () {
        cursorIcon.style.opacity = "0";
        noDownEl.style.cursor = "";
      });

      noDownEl.addEventListener("mouseleave", function () {
        if (cursorVisible) {
          cursorIcon.style.opacity = "1";
          element.style.cursor = "none";
        }
      });
    });

    // Click event to scroll to #content - Desktop only
    element.addEventListener("click", function (e) {
      // Ignoriere Klicks auf .no-down-cursor Elementen
      if (e.target.closest(".no-down-cursor")) return;

      if (cursorVisible) {
        e.preventDefault();

        const targetElement = document.querySelector("#content");
        if (targetElement && ScrollSmoother.get()) {
          ScrollSmoother.get().scrollTo(targetElement, true, "power2.out");

          // Nach 1 Sekunde Cursor ausblenden
          setTimeout(() => {
            cursorIcon.style.opacity = "0";
            cursorIcon.style.display = "none";
            cursorVisible = false;
            customCursorElements.forEach((el) => (el.style.cursor = ""));
          }, 1000);
        }
      }
    });
  });
});

// Anker-Navigation mit ScrollSmoother
document.addEventListener("DOMContentLoaded", function () {
  const anchorLinks = document.querySelectorAll('.ankerlink[href^="#"]');

  anchorLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const hash = this.getAttribute("href");

      if (hash && hash !== "#") {
        const targetElement = document.querySelector(hash);

        if (targetElement) {
          // Prüfe ob Mobile (< 1024px) oder Desktop
          const isMobile = window.matchMedia("(max-width: 1023px)").matches;

          // Unterschiedlicher Offset für Mobile und Desktop
          const offset = isMobile ? 0 : 0;
          const targetPosition = targetElement.offsetTop - offset;

          if (isMobile) {
            // Mobile: Natives Smooth Scrolling
            window.scrollTo({
              top: targetPosition,
              behavior: "smooth",
            });
          } else {
            // Desktop: ScrollSmoother (wenn verfügbar)
            if (ScrollSmoother.get()) {
              ScrollSmoother.get().scrollTo(targetPosition, true, "power2.out");
            } else {
              // Fallback falls ScrollSmoother nicht verfügbar
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
              });
            }
          }
        }
      }
    });
  });
});

//REMOVE .00 bei Zeiten bei ganzen Stunden
document.addEventListener("DOMContentLoaded", () => {
  const timeTexts = document.querySelectorAll(".time-text");

  timeTexts.forEach((el) => {
    console.log(el.innerText);
    el.innerText = el.innerText.replaceAll(".00", "");
  });
});

// Same Height für Boxen
document.addEventListener("DOMContentLoaded", function () {
  function setSameHeight() {
    const elements = document.querySelectorAll(".sameheight");

    if (elements.length === 0) return;

    // Reset heights first
    elements.forEach((el) => (el.style.height = "auto"));

    // Find max height
    let maxHeight = 0;
    elements.forEach((el) => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    // Set all to max height
    elements.forEach((el) => {
      el.style.height = maxHeight + "px";
    });
  }

  // Initial call
  setSameHeight();

  // Recalculate on window resize
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(setSameHeight, 250);
  });
});

// Link auf ganze Box anwenden
document.addEventListener("DOMContentLoaded", function () {
  const carouselCells = document.querySelectorAll(".linkbox");

  carouselCells.forEach((cell) => {
    cell.addEventListener("click", function (e) {
      // Finde den Link innerhalb der Cell
      const link = this.querySelector("a[href]");
      if (link && !e.target.closest("a")) {
        window.location.href = link.href;
      }
    });
  });
});

//replace .00 in time text only full hours
document.addEventListener("DOMContentLoaded", () => {
  const timeTexts = document.querySelectorAll(".time-text");

  timeTexts.forEach((el) => {
    console.log(el.innerText);
    el.innerText = el.innerText.replaceAll(".00", "");
  });
});

// Footer links stagger — ScrollSmoother-kompatibel, jetzt mit Reset on Leave
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const INIT_DELAY = 700;

    setTimeout(() => {
      if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}

      // ScrollSmoother-Check
      const isDesktop = window.matchMedia && window.matchMedia("(min-width: 1024px)").matches;
      const isTouch =
        "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
      const useScrollSmoother =
        isDesktop &&
        !isTouch &&
        window.ScrollSmoother &&
        window.ScrollSmoother.get &&
        window.ScrollSmoother.get();
      const scroller = useScrollSmoother ? document.querySelector("#smooth-content") : window;

      // --- Footer Links Animation (Stagger) ---
      const footerNav = document.querySelector(".footer-navigation-wrapper");
      const linkItems = footerNav ? footerNav.querySelectorAll(".footer-link-item") : [];
      let userInteracted = false,
        pendingPlay = false,
        played = false;
      const playFooterAnim = () => {
        if (played) return;
        played = true;
        gsap.to(linkItems, {
          y: 0,
          opacity: 1,
          duration: 0.7,
          stagger: { amount: 0.7, from: "start" },
          ease: "power2.out",
          overwrite: true,
        });
      };
      const resetLinks = () => {
        played = false;
        gsap.set(linkItems, { y: 40, opacity: 0, overwrite: true });
      };
      const onUserInteract = () => {
        if (userInteracted) return;
        userInteracted = true;
        if (pendingPlay) requestAnimationFrame(() => playFooterAnim());
        removeInteractionListeners();
      };
      const addInteractionListeners = () => {
        window.addEventListener("wheel", onUserInteract, { passive: true });
        window.addEventListener("touchstart", onUserInteract, { passive: true });
        window.addEventListener("keydown", onUserInteract, { passive: true });
        try {
          ScrollTrigger.addEventListener("scrollStart", onUserInteract);
        } catch (e) {}
      };
      const removeInteractionListeners = () => {
        window.removeEventListener("wheel", onUserInteract);
        window.removeEventListener("touchstart", onUserInteract);
        window.removeEventListener("keydown", onUserInteract);
        try {
          ScrollTrigger.removeEventListener("scrollStart", onUserInteract);
        } catch (e) {}
      };
      addInteractionListeners();

      // Reset nur wenn komplett aus dem Viewport (nach oben raus)
      const resetLinksImmediate = () => {
        pendingPlay = false;
        played = false;
        gsap.set(linkItems, { y: 40, opacity: 0, overwrite: true });
      };

      if (footerNav && linkItems.length) {
        resetLinks();
        ScrollTrigger.create({
          trigger: footerNav,
          scroller: useScrollSmoother ? scroller : window,
          start: "top 50%",
          markers: false,
          onEnter: () => {
            if (userInteracted) playFooterAnim();
            else pendingPlay = true;
          },
          onEnterBack: () => {
            if (userInteracted) playFooterAnim();
            else pendingPlay = true;
          },
          // Reset wird vom gemeinsamen Footer-Trigger gesteuert
          invalidateOnRefresh: true,
        });
      }

      // --- Sammle alle Footer-Sections für gemeinsamen Reset ---
      const footerSections = [];

      // --- Helper für Einzel-Animationen (nur onEnter, kein onLeaveBack) ---
      function animateFooterSection(selector, triggerStart = "top 60%", animationDelay = 0) {
        const el = document.querySelector(selector);
        if (!el) return;

        // Speichere Element für späteren Reset
        footerSections.push(el);

        gsap.set(el, { y: 40, opacity: 0, overwrite: true });
        ScrollTrigger.create({
          trigger: el,
          scroller: useScrollSmoother ? scroller : window,
          start: triggerStart,
          markers: false,
          onEnter: () => {
            gsap.to(el, {
              y: 0,
              opacity: 1,
              duration: 0.7,
              ease: "power2.out",
              delay: animationDelay,
              overwrite: true,
            });
          },
          onEnterBack: () => {
            gsap.to(el, {
              y: 0,
              opacity: 1,
              duration: 0.7,
              ease: "power2.out",
              delay: animationDelay,
              overwrite: true,
            });
          },
          invalidateOnRefresh: true,
        });
      }

      // --- Footer Einzelbereiche ---
      animateFooterSection(".footer-adress-section", "top 70%", 0.2);
      animateFooterSection(".footer-socialmedia-section", "top 70%", 0.3);
      animateFooterSection(".footer-sponsor-section", "top 70%");
      animateFooterSection(".footer-teaser-section", "top 70%");

      // --- Gemeinsamer Reset-Trigger für ALLE Footer-Elemente ---
      // Nutzt den Footer als Referenz - Reset erst wenn Footer komplett aus Viewport
      const footer = document.querySelector("footer");
      if (footer) {
        ScrollTrigger.create({
          trigger: footer,
          scroller: useScrollSmoother ? scroller : window,
          start: "top bottom", // Start wenn Footer-Top den Viewport-Bottom erreicht
          end: "bottom top", // Ende wenn Footer-Bottom den Viewport-Top verlässt
          markers: false,
          onLeaveBack: () => {
            // Reset ALLE Footer-Elemente wenn Footer komplett nach oben aus Viewport
            // Footer-Links
            resetLinksImmediate();
            // Footer-Sections
            footerSections.forEach((el) => {
              gsap.set(el, { y: 40, opacity: 0, overwrite: true });
            });
          },
          invalidateOnRefresh: true,
        });
      }

      // ScrollTrigger refresh für ScrollSmoother
      if (useScrollSmoother) {
        setTimeout(() => {
          try {
            ScrollTrigger.refresh();
          } catch (e) {}
        }, 200);
      } else {
        try {
          ScrollTrigger.refresh();
        } catch (e) {}
      }
    }, INIT_DELAY);
  });
})();

// iOS Safari: Hamburger-Position bei dynamischer Adressleiste korrigieren
// Wenn die Adressleiste ein-/ausfährt, ändert sich window.visualViewport.height.
// position:fixed wird an den Initial Containing Block (ICB) gebunden, nicht an
// den sichtbaren Viewport – der Hamburger muss daher manuell nachgeführt werden.
(function () {
  if (!window.visualViewport) return;

  var hamburger = document.getElementById("mobile-hamburger");
  if (!hamburger) return;

  function updateHamburgerBottom() {
    // Differenz zwischen visualViewport und window.innerHeight:
    // > 0 wenn Adressleiste versteckt (sichtbarer Bereich grösser als ICB)
    var offset = window.visualViewport.height - window.innerHeight;
    // offset ist auf Desktop immer 0 → kein Effekt
    hamburger.style.bottom = (offset > 0 ? offset : 0) + "px";
  }

  window.visualViewport.addEventListener("resize", updateHamburgerBottom);
  document.addEventListener("DOMContentLoaded", updateHamburgerBottom);
})();
